<div class="focus-offering-form">
  <div class="offering-form-header">
    <a rds-link standalone routerLink="/focus/my-offerings" class="mb-5">
      <rds-icon namespace="filled" icon="arrow_left" />
      {{ BUTTONS.BACK_TO_MY_OFFERINGS }}
    </a>

    <div class="title-row">
      @if (!offeringUUID()) {
        <h2 class="ui-heading-3-bold">{{ OFFERING_FORM.HEADERS.ADD_NEW }}</h2>
      } @else {
        <h2 class="ui-heading-3-bold">
          {{ OFFERING_FORM.HEADERS.EDIT }} {{ offeringName() }}
        </h2>
      }
      <button
        *inexpFeatureFlag="'focus_inexp_1361_save_draft'"
        rds-secondary-button
        (click)="handleDraftSave()"
        size="l"
        [disabled]="isDraftSaving()"
      >
        @if (isDraftSaving()) {
          <div class="loading-container">
            <rds-progress-spinner
              class="loading-spinner"
            ></rds-progress-spinner>
            {{ BUTTONS.DRAFT_SAVING }}
          </div>
        } @else {
          {{ BUTTONS.SAVE_DRAFT }}
        }
      </button>
    </div>
    <div>
      <rds-badge
        size="s"
        type="minimal"
        color="blue"
        class="platform-badge"
        [label]="OFFERING_FORM.HEADERS.OFFERING_TYPE">
      </rds-badge>
      <rds-badge
        size="s"
        type="minimal"
        color="blue"
        [label]="getContentStatusLabel(offering()?.publishedAt, offering()?.updatedAt)">
      </rds-badge>
    </div>
  </div>
  <div class="offering-form-content">
    @if (isLoading()) {
    <inexp-form-skeleton />
    } @else {
    <rds-stepper #stepper>
      <!-- 1 -->
      <rds-step
        [stepControl]="formPermissions"
        label="step_1_rolesAndPermissions"
      >
        <ng-template rdsStepLabel>{{ OFFERING_FORM.STEPS.STEP_1 }}</ng-template>
        <form class="form" [formGroup]="formPermissions">
          <fieldset class="form-box">
            <h3 class="ui-heading-3-bold mb-5 required">
              {{ OFFERING_FORM.PERMISSIONS.OWNER.SECTION_TITLE }}
            </h3>
            <div class="inputs">
              <!-- Owner email -->
              <rds-form-field labelPosition="top">
                <rds-control-label>{{
                  OFFERING_FORM.PERMISSIONS.OWNER.LABEL
                }}</rds-control-label>
                <input
                  rdsInput
                  formControlName="ownerEmail"
                  [placeholder]="OFFERING_FORM.PERMISSIONS.OWNER.PLACEHOLDER"
                />
                <rds-control-hint>{{
                  OFFERING_FORM.PERMISSIONS.OWNER.HINT
                }}</rds-control-hint>

                @if (
                  formPermissions.controls.ownerEmail.touched &&
                  formPermissions.controls.ownerEmail.hasError("required")
                ) {
                  <rds-control-error> {{ ERRORS.EMPTY }} </rds-control-error>
                }
                @if (
                  formPermissions.controls.ownerEmail.touched &&
                  formPermissions.controls.ownerEmail.hasError("strictEmail")
                ) {
                  <rds-control-error>
                    {{ ERRORS.INVALID_EMAIL }}
                  </rds-control-error>
                }
              </rds-form-field>
            </div>
          </fieldset>
          <fieldset class="form-box" aria-labelledby="offering-deputy-title">
            <h3
              class="ui-heading-3-bold mb-5 required"
              id="offering-deputy-title"
            >
              {{ OFFERING_FORM.PERMISSIONS.DEPUTY.SECTION_TITLE }}
            </h3>
            <div class="inputs">
              <!-- Deputy email -->
              <rds-form-field labelPosition="top">
                <rds-control-label>{{
                  OFFERING_FORM.PERMISSIONS.DEPUTY.LABEL
                }}</rds-control-label>
                <input
                  rdsInput
                  formControlName="deputyEmail"
                  [placeholder]="OFFERING_FORM.PERMISSIONS.DEPUTY.PLACEHOLDER"
                />
                <rds-control-hint>{{
                  OFFERING_FORM.PERMISSIONS.DEPUTY.HINT
                }}</rds-control-hint>
                @if (
                  formPermissions.controls.deputyEmail.touched &&
                  formPermissions.controls.deputyEmail.hasError("required")
                ) {
                  <rds-control-error> {{ ERRORS.EMPTY }} </rds-control-error>
                }
                @if (
                  formPermissions.controls.deputyEmail.touched &&
                  formPermissions.controls.deputyEmail.hasError("strictEmail")
                ) {
                  <rds-control-error>
                    {{ ERRORS.INVALID_EMAIL }}
                  </rds-control-error>
                }
              </rds-form-field>
            </div>
          </fieldset>
          <fieldset class="form-box" aria-labelledby="offering-author-title">
            <h3
              class="ui-heading-3-bold mb-5 required"
              id="offering-author-title"
            >
              {{ OFFERING_FORM.PERMISSIONS.AUTHOR.SECTION_TITLE }}
            </h3>
            <div class="inputs">
              <!-- Author's email -->
              <rds-form-field labelPosition="top">
                <rds-control-label>{{
                  OFFERING_FORM.PERMISSIONS.AUTHOR.LABEL
                }}</rds-control-label>

                <rds-input-with-chips formControlName="authorEmails">
                  <rds-chip-grid>
                    @for (author of authors(); track $index) {
                      <rds-input-chip
                        editable
                        [value]="author"
                        (edited)="onEditAuthor(author, $event)"
                        (closeChip)="removeAuthor(author)"
                      >
                        {{ author }}
                      </rds-input-chip>
                    }
                    <input
                      rds-input
                      rdsChipInput
                      #authorInput
                      (rdsChipInputTokenEnd)="addAuthor($event)"
                      (focusout)="onAuthorFocusOut(authorInput)"
                      [placeholder]="
                        OFFERING_FORM.PERMISSIONS.AUTHOR.PLACEHOLDER
                      "
                    />
                  </rds-chip-grid>
                </rds-input-with-chips>
                <rds-control-hint>{{
                  OFFERING_FORM.PERMISSIONS.AUTHOR.HINT
                }}</rds-control-hint>
                @if (
                  formPermissions.controls.authorEmails.touched &&
                  formPermissions.controls.authorEmails.hasError("required")
                ) {
                  <rds-control-error> {{ ERRORS.EMPTY }} </rds-control-error>
                }

                @if (
                  formPermissions.controls.authorEmails.touched &&
                  formPermissions.controls.authorEmails.hasError("emailList")
                ) {
                  <rds-control-error>
                    {{ ERRORS.INVALID_EMAIL }}
                  </rds-control-error>
                }
              </rds-form-field>
            </div>
          </fieldset>
        </form>
        <div class="form-action publish-and-next">
          @if (offeringUUID()) {
            <button
              rds-secondary-button
              (click)="handlePublish()"
              size="l"
              [disabled]="isPublishing()"
            >
              @if (isPublishing()) {
                <div class="loading-container">
                  <rds-progress-spinner
                    class="loading-spinner"
                  ></rds-progress-spinner>
                  {{ BUTTONS.PUBLISHING }}
                </div>
              } @else {
                {{ BUTTONS.PUBLISH }}
              }
            </button>
          }
          <button rds-primary-button rdsStepperNext size="l">
            {{ BUTTONS.NEXT_STEP }}
          </button>
        </div>
      </rds-step>

      <!-- 2 -->
      <rds-step [stepControl]="formOverview" label="step_2_offeringOverview">
        <ng-template rdsStepLabel>{{ OFFERING_FORM.STEPS.STEP_2 }}</ng-template>
        <form [formGroup]="formOverview" class="form">
          <fieldset class="form-box" aria-labelledby="general-info-title">
            <h3 class="ui-heading-3-bold mb-5 required" id="general-info-title">
              {{ OFFERING_FORM.OVERVIEW.GENERAL_INFO.SECTION_TITLE }}
            </h3>
            <div class="inputs">
              <!-- Display name -->
              <rds-form-field labelPosition="top">
                <rds-control-label>{{
                  OFFERING_FORM.OVERVIEW.GENERAL_INFO.DISPLAY_NAME.LABEL
                }}</rds-control-label>
                <input
                  rdsInput
                  formControlName="displayName"
                  [placeholder]="
                    OFFERING_FORM.OVERVIEW.GENERAL_INFO.DISPLAY_NAME.PLACEHOLDER
                  "
                />
                <rds-control-hint>{{
                  OFFERING_FORM.OVERVIEW.GENERAL_INFO.DISPLAY_NAME.HINT
                }}</rds-control-hint>
                @if (
                  formOverview.controls.displayName.touched &&
                  formOverview.controls.displayName.hasError("required")
                ) {
                  <rds-control-error> {{ ERRORS.EMPTY }} </rds-control-error>
                }
                @if (
                  formOverview.controls.displayName.touched &&
                  formOverview.controls.displayName.hasError("slugLength")
                ) {
                  <rds-control-error>{{
                    ERRORS.SLUG_LENGTH
                  }}</rds-control-error>
                }
                @if (
                  formOverview.controls.displayName.touched &&
                  formOverview.controls.displayName.hasError("slugDuplicate")
                ) {
                  <rds-control-error>{{
                    ERRORS.SLUG_DUPLICATE
                  }}</rds-control-error>
                }
              </rds-form-field>
              <!-- Approval status -->
              <rds-form-field labelPosition="top"
                ><rds-control-label>{{
                  OFFERING_FORM.OVERVIEW.GENERAL_INFO.APPROVAL_STATUS.LABEL
                }}</rds-control-label>
                <rds-select
                  formControlName="approvalStatus"
                  [placeholder]="
                    OFFERING_FORM.OVERVIEW.GENERAL_INFO.APPROVAL_STATUS
                      .PLACEHOLDER
                  "
                >
                  @for (
                    approvalStatus of approvalStatuses;
                    track approvalStatus
                  ) {
                    <rds-select-option [value]="approvalStatus">{{
                      approvalStatus
                    }}</rds-select-option>
                  }
                </rds-select>
                <rds-control-hint>{{
                  OFFERING_FORM.OVERVIEW.GENERAL_INFO.APPROVAL_STATUS.HINT
                }}</rds-control-hint>
                @if (
                  formOverview.controls.approvalStatus.touched &&
                  formOverview.controls.approvalStatus.errors
                ) {
                  <rds-control-error>
                    {{ ERRORS.EMPTY_SELECTION }}
                  </rds-control-error>
                }
              </rds-form-field>
              @if (
                formOverview.controls.approvalStatus.value !==
                  ApprovalStatus.APPROVED_PREFERRED &&
                formOverview.controls.approvalStatus.value !==
                  ApprovalStatus.APPROVED
              ) {
                <!-- Successor -->
                <rds-form-field labelPosition="top">
                  <rds-control-label>{{
                    OFFERING_FORM.OVERVIEW.GENERAL_INFO.SUCCESSOR.LABEL
                  }}</rds-control-label>
                  <rds-select
                    formControlName="successor"
                    [placeholder]="
                      OFFERING_FORM.OVERVIEW.GENERAL_INFO.SUCCESSOR.PLACEHOLDER
                    "
                    #select
                    (valueChange)="select.resetFilterValue()"
                    [filterBy]="filterBy"
                  >
                    <rds-select-search-input></rds-select-search-input>
                    <rds-select-option-separator></rds-select-option-separator>
                    @for (offering of offerings(); track offering.uuid) {
                      <rds-select-option [value]="offering.uuid">{{
                        offering.displayName
                      }}</rds-select-option>
                    }
                  </rds-select>
                  <rds-control-hint>{{
                    OFFERING_FORM.OVERVIEW.GENERAL_INFO.SUCCESSOR.HINT
                  }}</rds-control-hint>
                </rds-form-field>
              }
            </div>
          </fieldset>
          <fieldset
            class="form-box"
            aria-labelledby="offering-description-title"
          >
            <h3
              class="ui-heading-3-bold mb-5 required"
              id="offering-description-title"
            >
              {{ OFFERING_FORM.OVERVIEW.DESCRIPTION.SECTION_TITLE }}
            </h3>
            <div class="inputs">
              <!-- Offering description -->
              <rds-form-field labelPosition="top">
                <rds-control-label>{{
                  OFFERING_FORM.OVERVIEW.DESCRIPTION.LABEL
                }}</rds-control-label>
                <textarea
                  rdsInput
                  formControlName="description"
                  [placeholder]="OFFERING_FORM.OVERVIEW.DESCRIPTION.PLACEHOLDER"
                ></textarea>
                <rds-control-hint>{{
                  OFFERING_FORM.OVERVIEW.DESCRIPTION.HINT
                }}</rds-control-hint>
                @if (
                  formOverview.controls.description.touched &&
                  formOverview.controls.description.errors
                ) {
                  <rds-control-error> {{ ERRORS.EMPTY }} </rds-control-error>
                }
              </rds-form-field>
            </div>
          </fieldset>
          <fieldset
            class="form-box"
            aria-labelledby="offering-relationship-title"
          >
            <h3 class="ui-heading-3-bold mb-5" id="offering-relationship-title">
              {{ OFFERING_FORM.OVERVIEW.OFFERING_RELATIONSHIP.SECTION_TITLE }}
            </h3>
            <div class="inputs">
               <!-- Relationship type -->
                <rds-form-field labelPosition="top">
                  <rds-control-label>{{
                    OFFERING_FORM.OVERVIEW.OFFERING_RELATIONSHIP
                      .RELATIONSHIP_TYPE.LABEL
                  }}</rds-control-label>
                  <rds-select
                    formControlName="relationshipType"
                    [placeholder]="
                      OFFERING_FORM.OVERVIEW.OFFERING_RELATIONSHIP
                        .RELATIONSHIP_TYPE.PLACEHOLDER
                    "
                  >
                    @for (type of relationshipTypes; track type) {
                      <rds-select-option [value]="type">{{
                        type
                      }}</rds-select-option>
                    }
                  </rds-select>
                  <rds-control-hint>{{
                    OFFERING_FORM.OVERVIEW.OFFERING_RELATIONSHIP
                      .RELATIONSHIP_TYPE.HINT
                  }}</rds-control-hint>
                  @if (
                    formOverview.controls.relationshipType.touched &&
                    formOverview.controls.relationshipType.hasError("required")
                  ) {
                    <rds-control-error>{{
                      ERRORS.EMPTY_SELECTION
                    }}</rds-control-error>
                  }
                </rds-form-field>
                <!-- Select parent or child offering depending on relationship type -->
                @if (formOverview.controls.relationshipType.value) {
                  <rds-form-field labelPosition="top">
                    <rds-control-label>{{
                      formOverview.controls.relationshipType.value ===
                      OfferingRelationshipType.CHILD_OF
                        ? OFFERING_FORM.OVERVIEW.OFFERING_RELATIONSHIP
                            .SELECT_PARENT.LABEL
                        : OFFERING_FORM.OVERVIEW.OFFERING_RELATIONSHIP
                            .SELECT_CHILD.LABEL
                    }}</rds-control-label>
                    <rds-select
                      formControlName="relationshipTargetOfferingId"
                      [placeholder]="
                        formOverview.controls.relationshipType.value ===
                        OfferingRelationshipType.CHILD_OF
                          ? OFFERING_FORM.OVERVIEW.OFFERING_RELATIONSHIP
                              .SELECT_PARENT.PLACEHOLDER
                          : OFFERING_FORM.OVERVIEW.OFFERING_RELATIONSHIP
                              .SELECT_CHILD.PLACEHOLDER
                      "
                      #targetSelect
                      (valueChange)="targetSelect.resetFilterValue()"
                      [filterBy]="filterByOfferingName"
                    >
                      <rds-select-search-input></rds-select-search-input>
                      <rds-select-option-separator></rds-select-option-separator>
                      @for (offering of offerings(); track offering.uuid) {
                        <rds-select-option [value]="offering.uuid">{{
                          offering.displayName
                        }}</rds-select-option>
                      }
                    </rds-select>
                    <rds-control-hint>{{
                      formOverview.controls.relationshipType.value ===
                      OfferingRelationshipType.CHILD_OF
                        ? OFFERING_FORM.OVERVIEW.OFFERING_RELATIONSHIP
                            .SELECT_PARENT.HINT
                        : OFFERING_FORM.OVERVIEW.OFFERING_RELATIONSHIP
                            .SELECT_CHILD.HINT
                    }}</rds-control-hint>
                  </rds-form-field>
                }
            </div>
          </fieldset>
          <fieldset class="form-box" aria-labelledby="similar-offerings-title">
            <h3 class="ui-heading-3-bold mb-5" id="similar-offerings-title">
              {{ OFFERING_FORM.OVERVIEW.SIMILAR_OFFERINGS.SECTION_TITLE }}
            </h3>
            <div class="inputs">
              <!-- Similar offerings -->
              <rds-form-field labelPosition="top"
                ><rds-control-label>{{
                  OFFERING_FORM.OVERVIEW.SIMILAR_OFFERINGS.LABEL
                }}</rds-control-label>
                <rds-multi-autocomplete
                  formControlName="similarOfferings"
                  [options]="similarOfferingOptions()"
                  displayProperty="displayName"
                  uniqProperty="uuid"
                  [compareItem]="compareOfferings"
                  [filterBy]="filterOfferings"
                  [placeholder]="
                    OFFERING_FORM.OVERVIEW.SIMILAR_OFFERINGS.PLACEHOLDER
                  "
                  [minSearchChars]="0"
                  [debounce]="0"
                  multiMinimumInputWidth="125"
                />
                <rds-control-hint>{{
                  OFFERING_FORM.OVERVIEW.SIMILAR_OFFERINGS.HINT
                }}</rds-control-hint>
              </rds-form-field>
            </div>
          </fieldset>
        </form>
        <div class="form-actions">
          <button rds-secondary-button rdsStepperPrevious size="l">
            {{ BUTTONS.PREVIOUS_STEP }}
          </button>
          <div class="publish-and-next">
            @if (offeringUUID()) {
              <button
                rds-secondary-button
                (click)="handlePublish()"
                size="l"
                [disabled]="isPublishing()"
              >
                @if (isPublishing()) {
                  <div class="loading-container">
                    <rds-progress-spinner
                      class="loading-spinner"
                    ></rds-progress-spinner>
                    {{ BUTTONS.PUBLISHING }}
                  </div>
                } @else {
                  {{ BUTTONS.PUBLISH }}
                }
              </button>
            }
            <button rds-primary-button rdsStepperNext size="l">
              {{ BUTTONS.NEXT_STEP }}
            </button>
          </div>
        </div>
      </rds-step>

      <!-- 3 -->
      <rds-step [stepControl]="formDetails" label="step_3_offeringDetails">
        <ng-template rdsStepLabel>{{ OFFERING_FORM.STEPS.STEP_3 }}</ng-template>
        <form [formGroup]="formDetails" class="form">
          <!-- ONBOARDING INFORMATION -->
          <fieldset
            class="form-box"
            aria-labelledby="onboarding-information-title"
          >
            <h3
              class="ui-heading-3-bold mb-5 required"
              id="onboarding-information-title"
            >
              {{ OFFERING_FORM.DETAILS.ONBOARDING.SECTION_TITLE }}
            </h3>
            <div class="inputs">
              <div class="dialog-description">
                <rds-control-label>{{ OFFERING_FORM.DETAILS.ONBOARDING.ACCESS_INSTRUCTIONS.LABEL }}
                  <span class="rich-editor-field-asterisk"> * </span>
                </rds-control-label>
                <app-rich-text-editor formControlName="onboardingAccessInstructions"
                  [placeholder]="OFFERING_FORM.DETAILS.ONBOARDING.ACCESS_INSTRUCTIONS.PLACEHOLDER" [readonly]="false"
                  [minHeight]="200" [invalid]="formDetails.controls.onboardingAccessInstructions.touched && formDetails.controls.onboardingAccessInstructions.invalid">
                </app-rich-text-editor>
                @if (formDetails.controls.onboardingAccessInstructions.touched && formDetails.controls.onboardingAccessInstructions.invalid) {
                <div class="editor-error">
                  <rds-icon namespace="outlined" icon="warning_circle"></rds-icon>
                  <span>{{ ERRORS.EMPTY }}</span>
                </div>
                } @else {
                <rds-control-hint>
                  {{ POPUPS.COMMUNITY.DESCRIPTION_HINT }}
                </rds-control-hint>
                }
              </div>
            </div>
            <span class="ui-label-m-bold required mt-5">
              {{ OFFERING_FORM.DETAILS.ONBOARDING.LABEL }}
            </span>
            <p class="ui-body-s-bold">
              {{ OFFERING_FORM.DETAILS.ONBOARDING.HINT }}
            </p>
            <table
              rds-table
              [dataSource]="onboardingDataSource"
              alternation="vertical"
            >
              <ng-container rdsColumnDef="description">
                <th rds-header-cell *rdsHeaderCellDef class="required">
                  {{
                    OFFERING_FORM.DETAILS.ONBOARDING.TABLE_COLUMNS
                      .STEP_DESCRIPTION
                  }}
                </th>
                <td rds-cell *rdsCellDef="let element">
                  {{ element.description }}
                </td>
              </ng-container>

              <ng-container rdsColumnDef="referenceUrl">
                <th rds-header-cell *rdsHeaderCellDef>
                  {{
                    OFFERING_FORM.DETAILS.ONBOARDING.TABLE_COLUMNS.ACCESS_URL
                  }}
                </th>
                <td class="last-column" rds-cell *rdsCellDef="let element">
                  <span>{{ element.referenceUrl }}</span>
                  <div rdsDropdown class="options" autofocusFirstItem>
                    <button
                      rds-dropdown-toggle-icon-button
                      aria-label="More options"
                      type="button"
                    >
                      <rds-icon namespace="outlined" icon="more_vertical" />
                    </button>
                    <div *rdsDropdownMenu>
                      <ul rds-list-item-container>
                        <li>
                          <button
                            rds-list-item
                            (click)="handleOnboardingDialog(element)"
                          >
                            {{ BUTTONS.EDIT }}
                          </button>
                        </li>
                        <li>
                          <button
                            rds-list-item
                            (click)="handleDeleteOnboardingStep(element)"
                          >
                            {{ BUTTONS.DELETE }}
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </td>
              </ng-container>

              <tr rds-header-row *rdsHeaderRowDef="onboardingColumns"></tr>
              <tr rds-row *rdsRowDef="let row; columns: onboardingColumns"></tr>
            </table>
            <button
              class="table-action"
              rds-text-button
              (click)="handleOnboardingDialog()"
            >
              <rds-icon icon="plus" namespace="filled" />
              {{ OFFERING_FORM.DETAILS.ONBOARDING.CTA }}
            </button>
          </fieldset>

          <!-- SERVICES & REQUESTS -->
          <fieldset
            class="form-box"
            aria-labelledby="offering-service-request-title"
          >
            <h3
              class="ui-heading-3-bold mb-5 required"
              id="offering-service-request-title"
            >
              {{ OFFERING_FORM.DETAILS.SERVICE_AND_REQUEST.SECTION_TITLE }}
            </h3>
            <p class="ui-body-s-bold">
              {{ OFFERING_FORM.DETAILS.SERVICE_AND_REQUEST.HINT }}
            </p>
            <table
              rds-table
              [dataSource]="serviceAndRequestDataSource"
              alternation="vertical"
            >
              <ng-container rdsColumnDef="type">
                <th rds-header-cell *rdsHeaderCellDef class="required">
                  {{
                    OFFERING_FORM.DETAILS.SERVICE_AND_REQUEST.TABLE_COLUMNS.TYPE
                  }}
                </th>
                <td rds-cell *rdsCellDef="let element">
                  {{ element.type }}
                </td>
              </ng-container>

              <ng-container rdsColumnDef="title">
                <th rds-header-cell *rdsHeaderCellDef class="required">
                  {{
                    OFFERING_FORM.DETAILS.SERVICE_AND_REQUEST.TABLE_COLUMNS
                      .TITLE
                  }}
                </th>
                <td rds-cell *rdsCellDef="let element">
                  {{ element.title }}
                </td>
              </ng-container>

              <ng-container rdsColumnDef="destinationValue">
                <th rds-header-cell *rdsHeaderCellDef class="required">
                  {{
                    OFFERING_FORM.DETAILS.SERVICE_AND_REQUEST.TABLE_COLUMNS
                      .DESTINATION
                  }}
                </th>
                <td  rds-cell *rdsCellDef="let element">
                  {{ element.destinationValue }}

                </td>
              </ng-container>

              <ng-container rdsColumnDef="description">
                <th rds-header-cell *rdsHeaderCellDef>
                  {{
                    OFFERING_FORM.DETAILS.SERVICE_AND_REQUEST.TABLE_COLUMNS
                      .DESCRIPTION
                  }}
                </th>
                <td class="last-column" rds-cell *rdsCellDef="let element">
                  {{ element.description }}
                  <div rdsDropdown class="options" autofocusFirstItem>
                    <button
                      rds-dropdown-toggle-icon-button
                      aria-label="More options"
                      type="button"
                    >
                      <rds-icon namespace="outlined" icon="more_vertical" />
                    </button>
                    <div *rdsDropdownMenu>
                      <ul rds-list-item-container>
                        <li>
                          <button
                            rds-list-item
                            (click)="handleServiceAndRequestDialog(element)"
                          >
                            {{ BUTTONS.EDIT }}
                          </button>
                        </li>
                        <li>
                          <button
                            rds-list-item
                            (click)="handleDeleteServiceAndRequest(element)"
                          >
                            {{ BUTTONS.DELETE }}
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </td>
              </ng-container>

              <tr
                rds-header-row
                *rdsHeaderRowDef="serviceAndRequestColumns"
              ></tr>
              <tr
                rds-row
                *rdsRowDef="let row; columns: serviceAndRequestColumns"
              ></tr>
            </table>

            <button
              class="table-action"
              rds-text-button
              (click)="handleServiceAndRequestDialog()"
            >
              <rds-icon icon="plus" namespace="filled" />
              {{ OFFERING_FORM.DETAILS.SERVICE_AND_REQUEST.CTA }}
            </button>
          </fieldset>

          <!-- LICENSE -->
          <fieldset class="form-box" aria-labelledby="offering-license-title">
            <h3
              class="ui-heading-3-bold mb-5 required"
              id="offering-license-title"
            >
              {{ OFFERING_FORM.DETAILS.LICENSE.SECTION_TITLE }}
            </h3>
            <div class="inputs">
              <!-- License cost responsibility -->
              <rds-form-field labelPosition="top"
                ><rds-control-label>{{
                  OFFERING_FORM.DETAILS.LICENSE.LICENSE_COST_RESPONSIBILITY
                    .LABEL
                }}</rds-control-label>
                <rds-select
                  formControlName="licenseCostResponsibility"
                  [placeholder]="
                    OFFERING_FORM.DETAILS.LICENSE.LICENSE_COST_RESPONSIBILITY
                      .PLACEHOLDER
                  "
                >
                  @for (
                    licenseCostResponsbility of licenseCostResponsibilities;
                    track licenseCostResponsbility
                  ) {
                    <rds-select-option [value]="licenseCostResponsbility">{{
                      licenseCostResponsbility
                    }}</rds-select-option>
                  }
                </rds-select>
                <rds-control-hint>{{
                  OFFERING_FORM.DETAILS.LICENSE.LICENSE_COST_RESPONSIBILITY.HINT
                }}</rds-control-hint>
                @if (
                  formDetails.controls.licenseCostResponsibility.touched &&
                  formDetails.controls.licenseCostResponsibility.errors
                ) {
                  <rds-control-error>{{
                    ERRORS.EMPTY_SELECTION
                  }}</rds-control-error>
                }
              </rds-form-field>
              <!-- Pricing per user -->
              <div class="checkbox-field">
                <rds-checkbox
                  formControlName="isPerUserPricingAvailable"
                  name="isPerUserPricingAvailable"
                  [checked]="false"
                  >{{
                    OFFERING_FORM.DETAILS.LICENSE.PRICING_PER_USER.LABEL
                  }}</rds-checkbox
                >
                <span class="custom-hint">{{
                  OFFERING_FORM.DETAILS.LICENSE.PRICING_PER_USER.HINT
                }}</span>
              </div>

              <!-- Per user cost: value / currency / frequency -->
              <div class="cost-fields">
                <!-- Per user cost value -->
                <rds-form-field labelPosition="top">
                  <rds-control-label>{{
                    OFFERING_FORM.DETAILS.LICENSE.VALUE.LABEL
                  }}</rds-control-label>
                  <input
                    rdsInput
                    formControlName="perUserCostValue"
                    [placeholder]="
                      OFFERING_FORM.DETAILS.LICENSE.VALUE.PLACEHOLDER
                    "
                    type="number"
                  />
                  <rds-control-hint>{{
                    OFFERING_FORM.DETAILS.LICENSE.VALUE.HINT
                  }}</rds-control-hint>
                  @if (
                    formDetails.controls.perUserCostValue.touched &&
                    formDetails.controls.perUserCostValue.hasError(
                      "invalidDecimal"
                    )
                  ) {
                    <rds-control-error>{{
                      ERRORS.INVALID_FORMAT
                    }}</rds-control-error>
                  }
                  @if (
                    formDetails.controls.perUserCostValue.touched &&
                    formDetails.controls.perUserCostValue.hasError("required")
                  ) {
                    <rds-control-error>{{ ERRORS.EMPTY }}</rds-control-error>
                  }
                </rds-form-field>
                <!-- Currency -->
                <rds-form-field labelPosition="top">
                  <rds-control-label>{{
                    OFFERING_FORM.DETAILS.LICENSE.CURRENCY.LABEL
                  }}</rds-control-label>
                  <rds-select
                    formControlName="perUserCostCurrency"
                    [placeholder]="
                      OFFERING_FORM.DETAILS.LICENSE.CURRENCY.PLACEHOLDER
                    "
                  >
                    @for (currency of currencies; track currency) {
                      <rds-select-option [value]="currency">{{
                        currency
                      }}</rds-select-option>
                    }
                  </rds-select>
                  <rds-control-hint>{{
                    OFFERING_FORM.DETAILS.LICENSE.CURRENCY.HINT
                  }}</rds-control-hint>
                  @if (
                    formDetails.controls.perUserCostCurrency.touched &&
                    formDetails.controls.perUserCostCurrency.errors
                  ) {
                    <rds-control-error>{{
                      ERRORS.EMPTY_SELECTION
                    }}</rds-control-error>
                  }
                </rds-form-field>
                <!-- Per user cost frequency -->
                <rds-form-field labelPosition="top">
                  <rds-control-label>{{
                    OFFERING_FORM.DETAILS.LICENSE.PAYMENT_FREQUENCY.LABEL
                  }}</rds-control-label>
                  <rds-select
                    formControlName="perUserCostFrequency"
                    [placeholder]="
                      OFFERING_FORM.DETAILS.LICENSE.PAYMENT_FREQUENCY
                        .PLACEHOLDER
                    "
                  >
                    @for (frequency of frequencies; track frequency) {
                      <rds-select-option [value]="frequency">{{
                        frequency
                      }}</rds-select-option>
                    }
                  </rds-select>
                  <rds-control-hint>{{
                    OFFERING_FORM.DETAILS.LICENSE.PAYMENT_FREQUENCY.HINT
                  }}</rds-control-hint>
                  @if (
                    formDetails.controls.perUserCostFrequency.touched &&
                    formDetails.controls.perUserCostFrequency.errors
                  ) {
                    <rds-control-error>{{
                      ERRORS.EMPTY_SELECTION
                    }}</rds-control-error>
                  }
                </rds-form-field>
              </div>
            </div>
          </fieldset>

          <!-- DEVELOPMENT COST RESPONSIBILITY -->
          <fieldset
            class="form-box"
            aria-labelledby="offering-development-cost-title"
          >
            <h3
              class="ui-heading-3-bold mb-5 required"
              id="offering-development-cost-title"
            >
              {{ OFFERING_FORM.DETAILS.DEVELOPMENT_COST.SECTION_TITLE }}
            </h3>
            <div class="inputs">
              <!-- Development cost responsibility -->
              <rds-form-field labelPosition="top">
                <rds-control-label>{{
                  OFFERING_FORM.DETAILS.DEVELOPMENT_COST.RESPONSIBILITY.LABEL
                }}</rds-control-label>
                <rds-select
                  formControlName="developmentCostResponsibility"
                  [placeholder]="
                    OFFERING_FORM.DETAILS.DEVELOPMENT_COST.RESPONSIBILITY
                      .PLACEHOLDER
                  "
                >
                  @for (
                    responsibility of developmentCostResponsibilities;
                    track responsibility
                  ) {
                    <rds-select-option [value]="responsibility">{{
                      responsibility
                    }}</rds-select-option>
                  }
                </rds-select>
                <rds-control-hint>{{
                  OFFERING_FORM.DETAILS.DEVELOPMENT_COST.RESPONSIBILITY.HINT
                }}</rds-control-hint>
                @if (
                  formDetails.controls.developmentCostResponsibility.touched &&
                  formDetails.controls.developmentCostResponsibility.errors
                ) {
                  <rds-control-error>{{
                    ERRORS.EMPTY_SELECTION
                  }}</rds-control-error>
                }
              </rds-form-field>
              <!-- Other development cost details -->
              <rds-form-field labelPosition="top">
                <rds-control-label>{{
                  OFFERING_FORM.DETAILS.DEVELOPMENT_COST.OTHER_DETAILS.LABEL
                }}</rds-control-label>
                <input
                  rdsInput
                  formControlName="developmentCostResponsibilityOtherDetails"
                />
                <rds-control-hint>{{
                  OFFERING_FORM.DETAILS.DEVELOPMENT_COST.OTHER_DETAILS.HINT
                }}</rds-control-hint>
              </rds-form-field>
            </div>
          </fieldset>

          <!-- SUPPORT & MAINTENANCE COST RESPONSIBILITY -->
          <fieldset
            class="form-box"
            aria-labelledby="offering-support-maintenance-cost-title"
          >
            <h3
              class="ui-heading-3-bold mb-5 required"
              id="offering-support-maintenance-cost-title"
            >
              {{ OFFERING_FORM.DETAILS.SUPPORT_MAINTENANCE_COST.SECTION_TITLE }}
            </h3>
            <div class="inputs">
              <!-- Support maintenance cost responsibility -->
              <rds-form-field labelPosition="top">
                <rds-control-label>{{
                  OFFERING_FORM.DETAILS.SUPPORT_MAINTENANCE_COST.RESPONSIBILITY
                    .LABEL
                }}</rds-control-label>
                <rds-select
                  formControlName="supportMaintenanceCostResponsibility"
                  [placeholder]="
                    OFFERING_FORM.DETAILS.SUPPORT_MAINTENANCE_COST
                      .RESPONSIBILITY.PLACEHOLDER
                  "
                >
                  @for (
                    responsibility of supportMaintenanceCostResponsibilities;
                    track responsibility
                  ) {
                    <rds-select-option [value]="responsibility">{{
                      responsibility
                    }}</rds-select-option>
                  }
                </rds-select>
                <rds-control-hint>{{
                  OFFERING_FORM.DETAILS.SUPPORT_MAINTENANCE_COST.RESPONSIBILITY
                    .HINT
                }}</rds-control-hint>
                @if (
                  formDetails.controls.supportMaintenanceCostResponsibility
                    .touched &&
                  formDetails.controls.supportMaintenanceCostResponsibility
                    .errors
                ) {
                  <rds-control-error>{{
                    ERRORS.EMPTY_SELECTION
                  }}</rds-control-error>
                }
              </rds-form-field>
              <!-- Other support & maintenance cost details -->
              <rds-form-field labelPosition="top">
                <rds-control-label>{{
                  OFFERING_FORM.DETAILS.SUPPORT_MAINTENANCE_COST.OTHER_DETAILS
                    .LABEL
                }}</rds-control-label>
                <input
                  rdsInput
                  formControlName="supportMaintenanceCostResponsibilityOtherDetails"
                />
                <rds-control-hint>{{
                  OFFERING_FORM.DETAILS.SUPPORT_MAINTENANCE_COST.OTHER_DETAILS
                    .HINT
                }}</rds-control-hint>
              </rds-form-field>
            </div>
          </fieldset>

          <!-- ADDITIONAL COST CONSIDERATIONS -->
          <fieldset
            class="form-box"
            aria-labelledby="offering-additional-cost-cosiderations-title"
          >
            <h3
              class="ui-heading-3-bold mb-5"
              id="offering-additional-cost-cosiderations-title"
            >
              {{ OFFERING_FORM.DETAILS.ADDITIONAL_COST.SECTION_TITLE }}
            </h3>
            <div class="inputs">
              <!-- Additional cost considerations Checkbox -->

              <!-- Pricing per user -->
              <rds-checkbox
                formControlName="isAdditionalCostConsiderationsAvailable"
                [checked]="false"
              >{{
                  OFFERING_FORM.DETAILS.ADDITIONAL_COST
                    .ADDITIONAL_COST_CONSIDERATIONS.CHECKBOX_LABEL
                }}</rds-checkbox
              >

              @if (
                formDetails.controls.isAdditionalCostConsiderationsAvailable
                  .value
                ) {
                <!-- Additional cost considerations -->
                <rds-form-field labelPosition="top">
                  <rds-control-label>{{
                      OFFERING_FORM.DETAILS.ADDITIONAL_COST
                        .ADDITIONAL_COST_CONSIDERATIONS.LABEL
                    }}</rds-control-label>
                  <input
                    rdsInput
                    formControlName="additionalCostConsiderations"
                    [placeholder]="
                      OFFERING_FORM.DETAILS.ADDITIONAL_COST
                        .ADDITIONAL_COST_CONSIDERATIONS.PLACEHOLDER
                    "
                  />
                  <rds-control-hint>{{
                      OFFERING_FORM.DETAILS.ADDITIONAL_COST
                        .ADDITIONAL_COST_CONSIDERATIONS.HINT
                    }}</rds-control-hint>
                  @if (
                    formDetails.controls.additionalCostConsiderations.touched &&
                    formDetails.controls.additionalCostConsiderations.errors
                    ) {
                    <rds-control-error>{{ ERRORS.EMPTY }}</rds-control-error>
                  }
                </rds-form-field>
              }

              <!-- Other pricing models Checkbox -->

              <!-- Pricing per user -->
              <rds-checkbox
                formControlName="isOtherPricingModelsAvailable"
                [checked]="false"
              >{{
                  OFFERING_FORM.DETAILS.ADDITIONAL_COST.OTHER_PRICING_MODELS
                    .CHECKBOX_LABEL
                }}</rds-checkbox
              >

              @if (formDetails.controls.isOtherPricingModelsAvailable.value) {
                <!-- Other pricing models -->
                <rds-form-field labelPosition="top">
                  <rds-control-label>{{
                      OFFERING_FORM.DETAILS.ADDITIONAL_COST.OTHER_PRICING_MODELS
                        .LABEL
                    }}</rds-control-label>
                  <input
                    rdsInput
                    formControlName="otherPricingModels"
                    [placeholder]="
                      OFFERING_FORM.DETAILS.ADDITIONAL_COST.OTHER_PRICING_MODELS
                        .PLACEHOLDER
                    "
                  />
                  <rds-control-hint>{{
                      OFFERING_FORM.DETAILS.ADDITIONAL_COST.OTHER_PRICING_MODELS
                        .HINT
                    }}</rds-control-hint>
                  @if (
                    formDetails.controls.otherPricingModels.touched &&
                    formDetails.controls.otherPricingModels.errors
                    ) {
                    <rds-control-error>{{ ERRORS.EMPTY }}</rds-control-error>
                  }
                </rds-form-field>
              }
            </div>
          </fieldset>

          <!-- SUPPORT -->
          <fieldset class="form-box" aria-labelledby="offering-support-title">
            <h3
              class="ui-heading-3-bold mb-5 required"
              id="offering-support-title"
            >
              {{ OFFERING_FORM.DETAILS.SUPPORT.SECTION_TITLE }}
            </h3>
            <div class="inputs">
              <!-- Support -->
              <rds-form-field labelPosition="top"
                ><rds-control-label>{{
                  OFFERING_FORM.DETAILS.SUPPORT.AVAILABILITY.LABEL
                }}</rds-control-label>
                <rds-select
                  formControlName="isSupported"
                  [placeholder]="
                    OFFERING_FORM.DETAILS.SUPPORT.AVAILABILITY.PLACEHOLDER
                  "
                >
                  <rds-select-option [value]="true">
                    Supported
                  </rds-select-option>
                  <rds-select-option [value]="false">
                    Not supported
                  </rds-select-option>
                </rds-select>
                <rds-control-hint>{{
                  OFFERING_FORM.DETAILS.SUPPORT.AVAILABILITY.HINT
                }}</rds-control-hint>
                @if (
                  formDetails.controls.isSupported.touched &&
                  formDetails.controls.isSupported.errors
                ) {
                  <rds-control-error>
                    {{ ERRORS.EMPTY_SELECTION }}
                  </rds-control-error>
                }
              </rds-form-field>
            </div>

            @if (formDetails.controls.isSupported.value) {
              <span class="ui-label-m-bold required mt-5">
                {{ OFFERING_FORM.DETAILS.SUPPORT.CHANNEL.LABEL }}
              </span>
              <p class="ui-body-s-bold">
                {{ OFFERING_FORM.DETAILS.SUPPORT.CHANNEL.HINT }}
              </p>
              <table
                rds-table
                [dataSource]="supportChannelDataSource"
                alternation="vertical"
              >
                <ng-container rdsColumnDef="channelType">
                  <th rds-header-cell *rdsHeaderCellDef class="required">
                    {{
                      OFFERING_FORM.DETAILS.SUPPORT.CHANNEL.TABLE_COLUMNS
                        .CHANNEL_TYPE
                    }}
                  </th>
                  <td rds-cell *rdsCellDef="let element">
                    {{ element.channelType }}
                  </td>
                </ng-container>

                <ng-container rdsColumnDef="destinationValue">
                  <th rds-header-cell *rdsHeaderCellDef class="required">
                    {{
                      OFFERING_FORM.DETAILS.SUPPORT.CHANNEL.TABLE_COLUMNS
                        .DESTINATION
                    }}
                  </th>
                  <td rds-cell *rdsCellDef="let element">
                    <span>{{ element.destinationValue }}</span>
                  </td>
                </ng-container>

                <ng-container rdsColumnDef="description">
                  <th rds-header-cell *rdsHeaderCellDef>
                    {{
                      OFFERING_FORM.DETAILS.SUPPORT.CHANNEL.TABLE_COLUMNS
                        .DESCRIPTION
                    }}
                  </th>
                  <td rds-cell *rdsCellDef="let element">
                    <span>{{ element.description }}</span>
                  </td>
                </ng-container>

                <ng-container rdsColumnDef="serviceDeskName">
                  <th rds-header-cell *rdsHeaderCellDef class="required">
                    {{
                      OFFERING_FORM.DETAILS.SUPPORT.CHANNEL.TABLE_COLUMNS
                        .SERVICE_DESK_NAME
                    }}
                  </th>
                  <td class="last-column" rds-cell *rdsCellDef="let element">
                    {{ element.serviceDeskName }}
                    <div rdsDropdown class="options" autofocusFirstItem>
                      <button
                        rds-dropdown-toggle-icon-button
                        aria-label="More options"
                        type="button"
                      >
                        <rds-icon namespace="outlined" icon="more_vertical" />
                      </button>
                      <div *rdsDropdownMenu>
                        <ul rds-list-item-container>
                          <li>
                            <button
                              rds-list-item
                              (click)="handleSupportChannelDialog(element)"
                            >
                              {{ BUTTONS.EDIT }}
                            </button>
                          </li>
                          <li>
                            <button
                              rds-list-item
                              (click)="handleDeleteSupportChannel(element)"
                            >
                              {{ BUTTONS.DELETE }}
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </td>
                </ng-container>

                <tr
                  rds-header-row
                  *rdsHeaderRowDef="supportChannelColumns"
                ></tr>
                <tr
                  rds-row
                  *rdsRowDef="let row; columns: supportChannelColumns"
                ></tr>
              </table>

              <button
                class="table-action"
                rds-text-button
                (click)="handleSupportChannelDialog()"
              >
                <rds-icon icon="plus" namespace="filled" />
                {{ OFFERING_FORM.DETAILS.SUPPORT.CHANNEL.CTA }}
              </button>

              <span class="ui-label-m-bold required mt-5">
                {{ OFFERING_FORM.DETAILS.SUPPORT.HOUR.LABEL }}
              </span>
              <p class="ui-body-s-bold">
                {{ OFFERING_FORM.DETAILS.SUPPORT.HOUR.HINT }}
              </p>
              <table
                rds-table
                [dataSource]="supportHourDataSource"
                alternation="vertical"
              >
                <ng-container rdsColumnDef="days">
                  <th rds-header-cell *rdsHeaderCellDef class="required">
                    {{ OFFERING_FORM.DETAILS.SUPPORT.HOUR.TABLE_COLUMNS.DAYS }}
                  </th>
                  <td rds-cell *rdsCellDef="let element">
                    {{ element.days?.join(", ") }}
                  </td>
                </ng-container>

                <ng-container rdsColumnDef="startTime">
                  <th rds-header-cell *rdsHeaderCellDef class="required">
                    {{
                      OFFERING_FORM.DETAILS.SUPPORT.HOUR.TABLE_COLUMNS
                        .START_TIME
                    }}
                  </th>
                  <td rds-cell *rdsCellDef="let element">
                    <span>{{ element.startTime | date: "shortTime" }}</span>
                  </td>
                </ng-container>

                <ng-container rdsColumnDef="endTime">
                  <th rds-header-cell *rdsHeaderCellDef class="required">
                    {{
                      OFFERING_FORM.DETAILS.SUPPORT.HOUR.TABLE_COLUMNS.END_TIME
                    }}
                  </th>
                  <td rds-cell *rdsCellDef="let element">
                    <span>{{ element.endTime | date: "shortTime" }}</span>
                  </td>
                </ng-container>

                <ng-container rdsColumnDef="timezone">
                  <th rds-header-cell *rdsHeaderCellDef class="required">
                    {{
                      OFFERING_FORM.DETAILS.SUPPORT.HOUR.TABLE_COLUMNS.TIMEZONE
                    }}
                  </th>
                  <td rds-cell *rdsCellDef="let element">
                    <span>{{ element.timezone }}</span>
                  </td>
                </ng-container>

                <ng-container rdsColumnDef="responseTime">
                  <th rds-header-cell *rdsHeaderCellDef class="required">
                    {{
                      OFFERING_FORM.DETAILS.SUPPORT.HOUR.TABLE_COLUMNS
                        .RESPONSE_TIME
                    }}
                  </th>
                  <td class="last-column" rds-cell *rdsCellDef="let element">
                    {{ element.responseTime }}
                    <div rdsDropdown class="options" autofocusFirstItem>
                      <button
                        rds-dropdown-toggle-icon-button
                        aria-label="More options"
                        type="button"
                      >
                        <rds-icon namespace="outlined" icon="more_vertical" />
                      </button>
                      <div *rdsDropdownMenu>
                        <ul rds-list-item-container>
                          <li>
                            <button
                              rds-list-item
                              (click)="handleSupportHourDialog(element)"
                            >
                              {{ BUTTONS.EDIT }}
                            </button>
                          </li>
                          <li>
                            <button
                              rds-list-item
                              (click)="handleDeleteSupportHour(element)"
                            >
                              {{ BUTTONS.DELETE }}
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </td>
                </ng-container>

                <tr rds-header-row *rdsHeaderRowDef="supportHourColumns"></tr>
                <tr
                  rds-row
                  *rdsRowDef="let row; columns: supportHourColumns"
                ></tr>
              </table>

              <button
                class="table-action"
                rds-text-button
                (click)="handleSupportHourDialog()"
              >
                <rds-icon icon="plus" namespace="filled" />
                {{ OFFERING_FORM.DETAILS.SUPPORT.HOUR.CTA }}
              </button>
            }
          </fieldset>

          <!-- ENVIRONMENT & SLA -->
          <fieldset
            class="form-box"
            aria-labelledby="offering-environment-title"
          >
            <h3
              class="ui-heading-3-bold mb-5"
              id="offering-environment-title"
            >
              {{ OFFERING_FORM.DETAILS.ENVIRONMENT.SECTION_TITLE }}
            </h3>

            <p class="ui-body-s-bold">
              {{ OFFERING_FORM.DETAILS.ENVIRONMENT.HINT }}
            </p>
            <table
              rds-table
              [dataSource]="environmentDataSource"
              alternation="vertical"
            >
              <ng-container rdsColumnDef="name">
                <th rds-header-cell *rdsHeaderCellDef>
                  {{ OFFERING_FORM.DETAILS.ENVIRONMENT.TABLE_COLUMNS.NAME }}
                </th>
                <td rds-cell *rdsCellDef="let element">
                  {{ element.name }}
                </td>
              </ng-container>

              <ng-container rdsColumnDef="url">
                <th rds-header-cell *rdsHeaderCellDef>
                  {{ OFFERING_FORM.DETAILS.ENVIRONMENT.TABLE_COLUMNS.URL }}
                </th>
                <td rds-cell *rdsCellDef="let element">
                  <span>{{ element.url }}</span>
                </td>
              </ng-container>

              <ng-container rdsColumnDef="serviceLevelAgreement">
                <th rds-header-cell *rdsHeaderCellDef>
                  {{ OFFERING_FORM.DETAILS.ENVIRONMENT.TABLE_COLUMNS.SLA }}
                </th>
                <td class="last-column" rds-cell *rdsCellDef="let element">
                  {{ element.serviceLevelAgreement }}
                  <div rdsDropdown class="options" autofocusFirstItem>
                    <button
                      rds-dropdown-toggle-icon-button
                      aria-label="More options"
                      type="button"
                    >
                      <rds-icon namespace="outlined" icon="more_vertical" />
                    </button>
                    <div *rdsDropdownMenu>
                      <ul rds-list-item-container>
                        <li>
                          <button
                            rds-list-item
                            (click)="handleEnvironmentDialog(element)"
                          >
                            {{ BUTTONS.EDIT }}
                          </button>
                        </li>
                        <li>
                          <button
                            rds-list-item
                            (click)="handleDeleteEnvironment(element)"
                          >
                            {{ BUTTONS.DELETE }}
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </td>
              </ng-container>

              <tr rds-header-row *rdsHeaderRowDef="environmentColumns"></tr>
              <tr
                rds-row
                *rdsRowDef="let row; columns: environmentColumns"
              ></tr>
            </table>

            <button
              class="table-action"
              rds-text-button
              (click)="handleEnvironmentDialog()"
            >
              <rds-icon icon="plus" namespace="filled" />
              {{ OFFERING_FORM.DETAILS.ENVIRONMENT.CTA }}
            </button>
          </fieldset>

          <!-- VENDOR INFORMATION -->
          <fieldset class="form-box" aria-labelledby="offering-vendor-title">
            <h3
              class="ui-heading-3-bold mb-5 required"
              id="offering-vendor-title"
            >
              {{ OFFERING_FORM.DETAILS.VENDOR.SECTION_TITLE }}
            </h3>
            <div class="inputs">
              <rds-form-field labelPosition="top">
                <rds-control-label>{{
                  OFFERING_FORM.DETAILS.VENDOR.NAME.LABEL
                }}</rds-control-label>
                <input
                  rdsInput
                  formControlName="vendorName"
                  [placeholder]="OFFERING_FORM.DETAILS.VENDOR.NAME.PLACEHOLDER"
                />
                <rds-control-hint>{{
                  OFFERING_FORM.DETAILS.VENDOR.NAME.HINT
                }}</rds-control-hint>
                @if (
                  formDetails.controls.vendorName.touched &&
                  formDetails.controls.vendorName.errors
                ) {
                  <rds-control-error>{{ ERRORS.EMPTY }}</rds-control-error>
                }
              </rds-form-field>
              <rds-form-field labelPosition="top">
                <rds-control-label>{{
                  OFFERING_FORM.DETAILS.VENDOR.SUPPORT.LABEL
                }}</rds-control-label>
                <textarea
                  rdsInput
                  formControlName="vendorSupport"
                  [placeholder]="
                    OFFERING_FORM.DETAILS.VENDOR.SUPPORT.PLACEHOLDER
                  "
                ></textarea>
                <rds-control-hint>{{
                  OFFERING_FORM.DETAILS.VENDOR.SUPPORT.HINT
                }}</rds-control-hint>
              </rds-form-field>
              <rds-form-field labelPosition="top">
                <rds-control-label>{{
                  OFFERING_FORM.DETAILS.VENDOR.URL.LABEL
                }}</rds-control-label>
                <input rdsInput formControlName="vendorUrl" />
                <rds-control-hint>{{
                  OFFERING_FORM.DETAILS.VENDOR.URL.HINT
                }}</rds-control-hint>
                @if (
                  formDetails.controls.vendorUrl.touched &&
                  formDetails.controls.vendorUrl.hasError("invalidUrl")
                ) {
                  <rds-control-error>{{
                    ERRORS.INVALID_URL
                  }}</rds-control-error>
                }
              </rds-form-field>
            </div>
          </fieldset>

          <!-- EXTERNAL USE -->
          <fieldset
            class="form-box"
            aria-labelledby="offering-external-use-title"
          >
            <h3
              class="ui-heading-3-bold mb-5 required"
              id="offering-external-use-title"
            >
              {{ OFFERING_FORM.DETAILS.EXTERNAL_USE.SECTION_TITLE }}
            </h3>
            <div class="inputs">
              <rds-form-field labelPosition="top">
                <rds-control-label>{{
                  OFFERING_FORM.DETAILS.EXTERNAL_USE.LABEL
                }}</rds-control-label>
                <rds-select
                  formControlName="isExternalUseAllowed"
                  [placeholder]="OFFERING_FORM.DETAILS.EXTERNAL_USE.PLACEHOLDER"
                >
                  <rds-select-option [value]="true">Yes</rds-select-option>
                  <rds-select-option [value]="false">No</rds-select-option>
                </rds-select>
                <rds-control-hint>{{
                  OFFERING_FORM.DETAILS.EXTERNAL_USE.HINT
                }}</rds-control-hint>
                @if (
                  formDetails.controls.isExternalUseAllowed.touched &&
                  formDetails.controls.isExternalUseAllowed.errors
                ) {
                  <rds-control-error>{{
                    ERRORS.EMPTY_SELECTION
                  }}</rds-control-error>
                }
              </rds-form-field>
            </div>
          </fieldset>

          <!-- AVAILABLE VERSION -->
          <fieldset
            class="form-box"
            aria-labelledby="offering-available-version-title"
          >
            <h3
              class="ui-heading-3-bold mb-5"
              id="offering-available-version-title"
            >
              {{ OFFERING_FORM.DETAILS.AVAILABLE_VERSION.SECTION_TITLE }}
            </h3>

            <p class="ui-body-s-bold">
              {{ OFFERING_FORM.DETAILS.AVAILABLE_VERSION.HINT }}
            </p>
            <table
              rds-table
              [dataSource]="availableVersionDataSource"
              alternation="vertical"
            >
              <ng-container rdsColumnDef="version">
                <th rds-header-cell *rdsHeaderCellDef>
                  {{
                    OFFERING_FORM.DETAILS.AVAILABLE_VERSION.TABLE_COLUMNS
                      .VERSION
                  }}
                </th>
                <td rds-cell *rdsCellDef="let element">
                  {{ element.version }}
                </td>
              </ng-container>

              <ng-container rdsColumnDef="status">
                <th rds-header-cell *rdsHeaderCellDef>
                  {{
                    OFFERING_FORM.DETAILS.AVAILABLE_VERSION.TABLE_COLUMNS.STATUS
                  }}
                </th>
                <td rds-cell *rdsCellDef="let element">
                  <span>{{ element.status }}</span>
                </td>
              </ng-container>

              <ng-container rdsColumnDef="compatibility">
                <th rds-header-cell *rdsHeaderCellDef>
                  {{
                    OFFERING_FORM.DETAILS.AVAILABLE_VERSION.TABLE_COLUMNS
                      .COMPATIBILITY
                  }}
                </th>
                <td rds-cell *rdsCellDef="let element">
                  <span>{{ element.compatibility }}</span>
                </td>
              </ng-container>

              <ng-container rdsColumnDef="releaseDate">
                <th rds-header-cell *rdsHeaderCellDef>
                  {{
                    OFFERING_FORM.DETAILS.AVAILABLE_VERSION.TABLE_COLUMNS
                      .RELEASE_DATE
                  }}
                </th>
                <td rds-cell *rdsCellDef="let element">
                  <span>{{ element.releaseDate }}</span>
                </td>
              </ng-container>

              <ng-container rdsColumnDef="endOfLifeDate">
                <th rds-header-cell *rdsHeaderCellDef>
                  {{
                    OFFERING_FORM.DETAILS.AVAILABLE_VERSION.TABLE_COLUMNS
                      .END_OF_LIFE_DATE
                  }}
                </th>
                <td rds-cell *rdsCellDef="let element">
                  <span>{{ element.endOfLifeDate }}</span>
                </td>
              </ng-container>

              <ng-container rdsColumnDef="additionalInfo">
                <th rds-header-cell *rdsHeaderCellDef>
                  {{
                    OFFERING_FORM.DETAILS.AVAILABLE_VERSION.TABLE_COLUMNS
                      .ADDITIONAL_INFORMATION
                  }}
                </th>
                <td class="last-column" rds-cell *rdsCellDef="let element">
                  {{ element.additionalInfo }}
                  <div rdsDropdown class="options" autofocusFirstItem>
                    <button
                      rds-dropdown-toggle-icon-button
                      aria-label="More options"
                      type="button"
                    >
                      <rds-icon namespace="outlined" icon="more_vertical" />
                    </button>
                    <div *rdsDropdownMenu>
                      <ul rds-list-item-container>
                        <li>
                          <button
                            rds-list-item
                            (click)="handleAvailableVersionDialog(element)"
                          >
                            {{ BUTTONS.EDIT }}
                          </button>
                        </li>
                        <li>
                          <button
                            rds-list-item
                            (click)="handleDeleteAvailableVersion(element)"
                          >
                            {{ BUTTONS.DELETE }}
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </td>
              </ng-container>

              <tr
                rds-header-row
                *rdsHeaderRowDef="availableVersionColumns"
              ></tr>
              <tr
                rds-row
                *rdsRowDef="let row; columns: availableVersionColumns"
              ></tr>
            </table>

            <button
              class="table-action"
              rds-text-button
              (click)="handleAvailableVersionDialog()"
            >
              <rds-icon icon="plus" namespace="filled" />
              {{ OFFERING_FORM.DETAILS.AVAILABLE_VERSION.CTA }}
            </button>
          </fieldset>

          <!-- AVAILABLE ADD-ONS -->
          <fieldset class="form-box" aria-labelledby="offering-addons-title">
            <h3 class="ui-heading-3-bold mb-5" id="offering-addons-title">
              {{ OFFERING_FORM.DETAILS.ADDONS.SECTION_TITLE }}
            </h3>
            <div class="inputs">
              <div class="checkbox-field">
                <rds-checkbox formControlName="hasAddons">{{
                  OFFERING_FORM.DETAILS.ADDONS.CHECKBOX_LABEL
                }}</rds-checkbox>
                <span class="custom-hint">{{
                  OFFERING_FORM.DETAILS.ADDONS.CHECKBOX_HINT
                }}</span>
              </div>
            </div>

            @if (formDetails.controls.hasAddons.value) {
              <span class="ui-label-m-bold mt-5">{{
                OFFERING_FORM.DETAILS.ADDONS.TABLE_LABEL
              }}</span>
              <p class="ui-body-s-bold">
                {{ OFFERING_FORM.DETAILS.ADDONS.TABLE_HINT }}
              </p>
              <table
                rds-table
                [dataSource]="addonDataSource"
                alternation="vertical"
              >
                <ng-container rdsColumnDef="name">
                  <th rds-header-cell *rdsHeaderCellDef class="required">
                    {{ OFFERING_FORM.DETAILS.ADDONS.TABLE_COLUMNS.NAME }}
                  </th>
                  <td rds-cell *rdsCellDef="let element">
                    {{ element.name }}
                  </td>
                </ng-container>

                <ng-container rdsColumnDef="description">
                  <th rds-header-cell *rdsHeaderCellDef class="required">
                    {{ OFFERING_FORM.DETAILS.ADDONS.TABLE_COLUMNS.DESCRIPTION }}
                  </th>
                  <td rds-cell *rdsCellDef="let element">
                    {{ element.description }}
                  </td>
                </ng-container>

                <ng-container rdsColumnDef="cost">
                  <th rds-header-cell *rdsHeaderCellDef class="required">
                    {{ OFFERING_FORM.DETAILS.ADDONS.TABLE_COLUMNS.COST }}
                  </th>
                  <td rds-cell *rdsCellDef="let element">
                    {{ element.cost }}
                  </td>
                </ng-container>

                <ng-container rdsColumnDef="support">
                  <th rds-header-cell *rdsHeaderCellDef>
                    {{ OFFERING_FORM.DETAILS.ADDONS.TABLE_COLUMNS.SUPPORT }}
                  </th>
                  <td rds-cell *rdsCellDef="let element">
                    {{ element.support ? "Yes" : "No" }}
                  </td>
                </ng-container>

                <ng-container rdsColumnDef="url">
                  <th rds-header-cell *rdsHeaderCellDef>
                    {{ OFFERING_FORM.DETAILS.ADDONS.TABLE_COLUMNS.URL }}
                  </th>
                  <td class="last-column" rds-cell *rdsCellDef="let element">
                    <span>{{ element.url }}</span>
                    <div rdsDropdown class="options" autofocusFirstItem>
                      <button
                        rds-dropdown-toggle-icon-button
                        aria-label="More options"
                        type="button"
                      >
                        <rds-icon namespace="outlined" icon="more_vertical" />
                      </button>
                      <div *rdsDropdownMenu>
                        <ul rds-list-item-container>
                          <li>
                            <button
                              rds-list-item
                              (click)="handleAddonDialog(element)"
                            >
                              {{ BUTTONS.EDIT }}
                            </button>
                          </li>
                          <li>
                            <button
                              rds-list-item
                              (click)="handleDeleteAddon(element)"
                            >
                              {{ BUTTONS.DELETE }}
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </td>
                </ng-container>

                <tr rds-header-row *rdsHeaderRowDef="addonColumns"></tr>
                <tr rds-row *rdsRowDef="let row; columns: addonColumns"></tr>
              </table>

              <button
                class="table-action"
                rds-text-button
                (click)="handleAddonDialog()"
              >
                <rds-icon icon="plus" namespace="filled" />
                {{ OFFERING_FORM.DETAILS.ADDONS.CTA }}
              </button>
            }
          </fieldset>

          <!-- COMMUNITY -->
          <fieldset class="form-box" aria-labelledby="offering-community-title">
            <h3 class="ui-heading-3-bold mb-5" id="offering-community-title">
              {{ OFFERING_FORM.DETAILS.COMMUNITY.SECTION_TITLE }}
            </h3>
            <p class="ui-body-s-bold">
              {{ OFFERING_FORM.DETAILS.COMMUNITY.HINT }}
            </p>
            <table
              rds-table
              [dataSource]="communityDataSource"
              alternation="vertical"
            >
              <ng-container rdsColumnDef="title">
                <th rds-header-cell *rdsHeaderCellDef class="required">
                  {{ OFFERING_FORM.DETAILS.COMMUNITY.TABLE_COLUMNS.TITLE }}
                </th>
                <td rds-cell *rdsCellDef="let element">
                  {{ element.title }}
                </td>
              </ng-container>

              <ng-container rdsColumnDef="description">
                <th rds-header-cell *rdsHeaderCellDef class="required">
                  {{
                    OFFERING_FORM.DETAILS.COMMUNITY.TABLE_COLUMNS.DESCRIPTION
                  }}
                </th>
                <td rds-cell *rdsCellDef="let element">
                  {{ element.description }}
                </td>
              </ng-container>

              <ng-container rdsColumnDef="url">
                <th rds-header-cell *rdsHeaderCellDef class="required">
                  {{ OFFERING_FORM.DETAILS.COMMUNITY.TABLE_COLUMNS.URL }}
                </th>
                <td class="last-column" rds-cell *rdsCellDef="let element">
                  {{ element.url }}
                  <div rdsDropdown class="options" autofocusFirstItem>
                    <button
                      rds-dropdown-toggle-icon-button
                      aria-label="More options"
                      type="button"
                    >
                      <rds-icon namespace="outlined" icon="more_vertical" />
                    </button>
                    <div *rdsDropdownMenu>
                      <ul rds-list-item-container>
                        <li>
                          <button
                            rds-list-item
                            (click)="handleCommunityDialog(element)"
                          >
                            {{ BUTTONS.EDIT }}
                          </button>
                        </li>
                        <li>
                          <button
                            rds-list-item
                            (click)="handleDeleteCommunity(element)"
                          >
                            {{ BUTTONS.DELETE }}
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </td>
              </ng-container>

              <tr rds-header-row *rdsHeaderRowDef="communityColumns"></tr>
              <tr rds-row *rdsRowDef="let row; columns: communityColumns"></tr>
            </table>

            <button
              class="table-action"
              rds-text-button
              (click)="handleCommunityDialog()"
            >
              <rds-icon icon="plus" namespace="filled" />
              {{ OFFERING_FORM.DETAILS.COMMUNITY.CTA }}
            </button>
          </fieldset>

          <!-- HOSTING INFORMATION -->
          <fieldset
            class="form-box"
            aria-labelledby="offering-hosting-information-title"
          >
            <h3
              class="ui-heading-3-bold mb-5"
              id="offering-hosting-information-title"
            >
              {{ OFFERING_FORM.DETAILS.HOSTING.SECTION_TITLE }}
            </h3>
            <p class="ui-body-s-bold">
              {{ OFFERING_FORM.DETAILS.HOSTING.HINT }}
            </p>
            <table
              rds-table
              [dataSource]="hostingDataSource"
              alternation="vertical"
            >
              <ng-container rdsColumnDef="name">
                <th rds-header-cell *rdsHeaderCellDef class="required">
                  {{ OFFERING_FORM.DETAILS.HOSTING.TABLE_COLUMNS.NAME }}
                </th>
                <td rds-cell *rdsCellDef="let element">
                  {{ element.name }}
                </td>
              </ng-container>

              <ng-container rdsColumnDef="type">
                <th rds-header-cell *rdsHeaderCellDef class="required">
                  {{ OFFERING_FORM.DETAILS.HOSTING.TABLE_COLUMNS.TYPE }}
                </th>
                <td rds-cell *rdsCellDef="let element">
                  {{ element.type }}
                </td>
              </ng-container>

              <ng-container rdsColumnDef="managed">
                <th rds-header-cell *rdsHeaderCellDef class="required">
                  {{ OFFERING_FORM.DETAILS.HOSTING.TABLE_COLUMNS.MANAGED }}
                </th>
                <td class="last-column" rds-cell *rdsCellDef="let element">
                  {{ element.managed }}
                  <div rdsDropdown class="options" autofocusFirstItem>
                    <button
                      rds-dropdown-toggle-icon-button
                      aria-label="More options"
                      type="button"
                    >
                      <rds-icon namespace="outlined" icon="more_vertical" />
                    </button>
                    <div *rdsDropdownMenu>
                      <ul rds-list-item-container>
                        <li>
                          <button
                            rds-list-item
                            (click)="handlehostingDialog(element)"
                          >
                            {{ BUTTONS.EDIT }}
                          </button>
                        </li>
                        <li>
                          <button
                            rds-list-item
                            (click)="handleDeletehosting(element)"
                          >
                            {{ BUTTONS.DELETE }}
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </td>
              </ng-container>

              <tr rds-header-row *rdsHeaderRowDef="hostingColumns"></tr>
              <tr rds-row *rdsRowDef="let row; columns: hostingColumns"></tr>
            </table>

            <button
              class="table-action"
              rds-text-button
              (click)="handlehostingDialog()"
            >
              <rds-icon icon="plus" namespace="filled" />
              {{ OFFERING_FORM.DETAILS.HOSTING.CTA }}
            </button>
          </fieldset>

          <!-- SYSTEM RISK ASSESSMENT -->
          <fieldset class="form-box" aria-labelledby="offering-sra-title">
            <h3 class="ui-heading-3-bold mb-5" id="offering-sra-title">
              {{ OFFERING_FORM.DETAILS.SRA.SECTION_TITLE }}
            </h3>
            <div class="inputs">
              <!-- SRA ID -->
              <rds-form-field labelPosition="top">
                <rds-control-label>{{
                  OFFERING_FORM.DETAILS.SRA.ASSESSMENT_ID.LABEL
                }}</rds-control-label>
                <input
                  rdsInput
                  formControlName="systemRiskAssessmentName"
                  [placeholder]="
                    OFFERING_FORM.DETAILS.SRA.ASSESSMENT_ID.PLACEHOLDER
                  "
                />
                <rds-control-hint>{{
                  OFFERING_FORM.DETAILS.SRA.ASSESSMENT_ID.HINT
                }}</rds-control-hint>
                @if (
                  formDetails.controls.systemRiskAssessmentName.touched &&
                  formDetails.controls.systemRiskAssessmentName.errors
                ) {
                  <rds-control-error> {{ ERRORS.EMPTY }} </rds-control-error>
                }
              </rds-form-field>
              <!-- Data Classification Level -->
              <rds-form-field labelPosition="top"
                ><rds-control-label>{{
                  OFFERING_FORM.DETAILS.SRA.DATA_CONFIDENTIALITY.LABEL
                }}</rds-control-label>
                <rds-select
                  formControlName="classificationLevel"
                  [placeholder]="
                    OFFERING_FORM.DETAILS.SRA.DATA_CONFIDENTIALITY.PLACEHOLDER
                  "
                >
                  @for (
                    classification of classifications;
                    track classification
                  ) {
                    <rds-select-option [value]="classification">{{
                      classification
                    }}</rds-select-option>
                  }
                </rds-select>
                <rds-control-hint>{{
                  OFFERING_FORM.DETAILS.SRA.DATA_CONFIDENTIALITY.HINT
                }}</rds-control-hint>
                @if (
                  formDetails.controls.classificationLevel.touched &&
                  formDetails.controls.classificationLevel.errors
                ) {
                  <rds-control-error>
                    {{ ERRORS.EMPTY_SELECTION }}
                  </rds-control-error>
                }
              </rds-form-field>
              <!-- SRA Required for solutions -->
              <rds-checkbox formControlName="isSraRequired">
                {{ OFFERING_FORM.DETAILS.SRA.REQUIRED_FOR_SOLUTIONS.LABEL }}
              </rds-checkbox>
            </div>
          </fieldset>

          <!-- SUPPORTED DATA CLASSIFICATION -->
          <fieldset
            class="form-box"
            aria-labelledby="offering-supported-classification-title"
          >
            <h3
              class="ui-heading-3-bold mb-5"
              id="offering-supported-classification-title"
            >
              {{
                OFFERING_FORM.DETAILS.SUPPORTED_DATA_CLASSIFICATION
                  .SECTION_TITLE
              }}
            </h3>
            <div class="inputs">
              <rds-form-field labelPosition="top">
                <rds-control-label>{{
                  OFFERING_FORM.DETAILS.SUPPORTED_DATA_CLASSIFICATION
                    .CLASSIFICATION_LEVEL.LABEL
                }}</rds-control-label>
                <rds-select
                  formControlName="supportedDataClassificationLevel"
                  [placeholder]="
                    OFFERING_FORM.DETAILS.SUPPORTED_DATA_CLASSIFICATION
                      .CLASSIFICATION_LEVEL.PLACEHOLDER
                  "
                >
                  @for (
                    classification of classifications;
                    track classification
                  ) {
                    <rds-select-option [value]="classification">{{
                      classification
                    }}</rds-select-option>
                  }
                </rds-select>
              </rds-form-field>
              <rds-form-field labelPosition="top">
                <rds-control-label>{{
                  OFFERING_FORM.DETAILS.SUPPORTED_DATA_CLASSIFICATION
                    .ADDITIONAL_INFORMATION.LABEL
                }}</rds-control-label>
                <input
                  rdsInput
                  formControlName="supportedDataClassificationAdditionalInformation"
                  [placeholder]="
                    OFFERING_FORM.DETAILS.SUPPORTED_DATA_CLASSIFICATION
                      .ADDITIONAL_INFORMATION.PLACEHOLDER
                  "
                />
              </rds-form-field>
            </div>
          </fieldset>

          <!-- SSO -->
          <fieldset class="form-box" aria-labelledby="offering-sso-title">
            <h3 class="ui-heading-3-bold mb-5" id="offering-sso-title">
              {{ OFFERING_FORM.DETAILS.SSO.SECTION_TITLE }}
            </h3>
            <div class="inputs">
              <!-- SSO -->
              <div class="checkbox-field">
                <rds-checkbox
                  formControlName="isSingleSignOnSupported"
                  name="isSingleSignOnSupported"
                  [checked]="false"
                  >{{
                    OFFERING_FORM.DETAILS.SSO.SUPPORT.CHECKBOX_LABEL
                  }}</rds-checkbox
                >
                <span class="custom-hint">{{
                  OFFERING_FORM.DETAILS.SSO.SUPPORT.HINT
                }}</span>
              </div>

              @if (formDetails.controls.isSingleSignOnSupported.value) {
                <!-- SSO providers -->
                <rds-form-field labelPosition="top">
                  <rds-control-label>{{
                    OFFERING_FORM.DETAILS.SSO.PROVIDER.LABEL
                  }}</rds-control-label>
                  <input
                    rdsInput
                    formControlName="singleSignOnProviders"
                    [placeholder]="
                      OFFERING_FORM.DETAILS.SSO.PROVIDER.PLACEHOLDER
                    "
                  />
                  <rds-control-hint>{{
                    OFFERING_FORM.DETAILS.SSO.PROVIDER.HINT
                  }}</rds-control-hint>
                  @if (
                    formDetails.controls.singleSignOnProviders.touched &&
                    formDetails.controls.singleSignOnProviders.errors
                  ) {
                    <rds-control-error>{{ ERRORS.EMPTY }}</rds-control-error>
                  }
                </rds-form-field>
              }
            </div>
          </fieldset>

          <!-- AI AGENT -->
          <fieldset class="form-box" aria-labelledby="offering-ai-agent-title">
            <h3 class="ui-heading-3-bold mb-5" id="offering-ai-agent-title">
              {{ OFFERING_FORM.DETAILS.AI_AGENT.SECTION_TITLE }}
            </h3>
            <p class="ui-body-s-bold">
              {{ OFFERING_FORM.DETAILS.AI_AGENT.HINT }}
            </p>
            <table
              rds-table
              [dataSource]="agentDataSource"
              alternation="vertical"
            >
              <ng-container rdsColumnDef="name">
                <th rds-header-cell *rdsHeaderCellDef class="required">
                  {{ OFFERING_FORM.DETAILS.AI_AGENT.TABLE_COLUMNS.NAME }}
                </th>
                <td rds-cell *rdsCellDef="let element">
                  {{ element.name }}
                </td>
              </ng-container>

              <ng-container rdsColumnDef="url">
                <th rds-header-cell *rdsHeaderCellDef class="required">
                  {{ OFFERING_FORM.DETAILS.AI_AGENT.TABLE_COLUMNS.URL }}
                </th>
                <td class="last-column" rds-cell *rdsCellDef="let element">
                  {{ element.url }}
                  <div rdsDropdown class="options" autofocusFirstItem>
                    <button
                      rds-dropdown-toggle-icon-button
                      aria-label="More options"
                      type="button"
                    >
                      <rds-icon namespace="outlined" icon="more_vertical" />
                    </button>
                    <div *rdsDropdownMenu>
                      <ul rds-list-item-container>
                        <li>
                          <button
                            rds-list-item
                            (click)="handleAgentDialog(element)"
                          >
                            {{ BUTTONS.EDIT }}
                          </button>
                        </li>
                        <li>
                          <button
                            rds-list-item
                            (click)="handleDeleteAgent(element)"
                          >
                            {{ BUTTONS.DELETE }}
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </td>
              </ng-container>

              <tr rds-header-row *rdsHeaderRowDef="agentColumns"></tr>
              <tr rds-row *rdsRowDef="let row; columns: agentColumns"></tr>
            </table>

            <button
              class="table-action"
              rds-text-button
              (click)="handleAgentDialog()"
            >
              <rds-icon icon="plus" namespace="filled" />
              {{ OFFERING_FORM.DETAILS.AI_AGENT.CTA }}
            </button>
          </fieldset>
        </form>
        <div class="form-actions">
          <button rds-secondary-button rdsStepperPrevious size="l">
            {{ BUTTONS.PREVIOUS_STEP }}
          </button>
          <div class="publish-and-next">
            @if (offeringUUID()) {
              <button
                rds-secondary-button
                (click)="handlePublish()"
                size="l"
                [disabled]="isPublishing()"
              >
                @if (isPublishing()) {
                  <div class="loading-container">
                    <rds-progress-spinner
                      class="loading-spinner"
                    ></rds-progress-spinner>
                    {{ BUTTONS.PUBLISHING }}
                  </div>
                } @else {
                  {{ BUTTONS.PUBLISH }}
                }
              </button>
            }
            <button rds-primary-button rdsStepperNext size="l">
              {{ BUTTONS.NEXT_STEP }}
            </button>
          </div>
        </div>
      </rds-step>

      <!-- 4 -->
      <rds-step [stepControl]="formFunctionality" label="step_4_functionality">
        <ng-template rdsStepLabel>{{ OFFERING_FORM.STEPS.STEP_4 }}</ng-template>
        <form class="form">
          <fieldset class="form-box" aria-labelledby="offering-feature-title">
            <h3
              class="ui-heading-3-bold mb-5 required"
              id="offering-feature-title"
            >
              {{ OFFERING_FORM.FUNCTIONALITY.FEATURES.SECTION_TITLE }}
            </h3>

            <p class="ui-body-s-bold">
              {{ OFFERING_FORM.FUNCTIONALITY.FEATURES.HINT }}
            </p>
            <table
              rds-table
              [dataSource]="featureDataSource"
              alternation="vertical"
            >
              <ng-container rdsColumnDef="name">
                <th rds-header-cell *rdsHeaderCellDef class="required">
                  {{
                    OFFERING_FORM.FUNCTIONALITY.FEATURES.TABLE_COLUMNS
                      .FEATURE_NAME
                  }}
                </th>
                <td rds-cell *rdsCellDef="let element">
                  <span>{{ element.name }}</span>
                </td>
              </ng-container>

              <ng-container rdsColumnDef="description">
                <th rds-header-cell *rdsHeaderCellDef class="required">
                  {{
                    OFFERING_FORM.FUNCTIONALITY.FEATURES.TABLE_COLUMNS
                      .FEATURE_DESCRIPTION
                  }}
                </th>
                <td rds-cell *rdsCellDef="let element">
                  <span>{{ element.description }}</span>
                </td>
              </ng-container>

              <ng-container rdsColumnDef="benefit">
                <th rds-header-cell *rdsHeaderCellDef class="required">
                  {{
                    OFFERING_FORM.FUNCTIONALITY.FEATURES.TABLE_COLUMNS
                      .FEATURE_BENEFIT
                  }}
                </th>
                <td class="last-column" rds-cell *rdsCellDef="let element">
                  <span>{{ element.benefit }}</span>
                  <div rdsDropdown class="options" autofocusFirstItem>
                    <button
                      rds-dropdown-toggle-icon-button
                      aria-label="More options"
                      type="button"
                    >
                      <rds-icon namespace="outlined" icon="more_vertical" />
                    </button>
                    <div *rdsDropdownMenu>
                      <ul rds-list-item-container>
                        <li>
                          <button
                            rds-list-item
                            (click)="handleFeatureDialog(element)"
                          >
                            {{ BUTTONS.EDIT }}
                          </button>
                        </li>
                        <li>
                          <button
                            rds-list-item
                            (click)="handleDeleteFeature(element)"
                          >
                            {{ BUTTONS.DELETE }}
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </td>
              </ng-container>

              <tr rds-header-row *rdsHeaderRowDef="featureColumns"></tr>
              <tr rds-row *rdsRowDef="let row; columns: featureColumns"></tr>
            </table>

            <button
              class="table-action"
              rds-text-button
              (click)="handleFeatureDialog()"
            >
              <rds-icon icon="plus" namespace="filled" />
              {{ OFFERING_FORM.FUNCTIONALITY.FEATURES.CTA }}
            </button>
          </fieldset>
          <fieldset
            class="form-box"
            aria-labelledby="offering-capabilities-title"
          >
            <h3
              class="ui-heading-3-bold mb-5 required"
              id="offering-capabilities-title"
            >
              {{ OFFERING_FORM.FUNCTIONALITY.CAPABILITIES.SECTION_TITLE }}
            </h3>

            <p class="ui-body-s-bold">
              {{ OFFERING_FORM.FUNCTIONALITY.CAPABILITIES.HINT }}
            </p>
            <table
              rds-table
              [dataSource]="capabilityDataSource"
              alternation="vertical"
            >
              <ng-container rdsColumnDef="name">
                <th rds-header-cell *rdsHeaderCellDef class="required">
                  {{
                    OFFERING_FORM.FUNCTIONALITY.CAPABILITIES.TABLE_COLUMNS
                      .CAPABILITY_NAME
                  }}
                </th>
                <td rds-cell *rdsCellDef="let element">
                  <span>{{ element.name }}</span>
                </td>
              </ng-container>

              <ng-container rdsColumnDef="description">
                <th rds-header-cell *rdsHeaderCellDef class="required">
                  {{
                    OFFERING_FORM.FUNCTIONALITY.CAPABILITIES.TABLE_COLUMNS
                      .CAPABILITY_DESCRIPTION
                  }}
                </th>
                <td rds-cell *rdsCellDef="let element">
                  <span>{{ element.description }}</span>
                </td>
              </ng-container>

              <ng-container rdsColumnDef="benefit">
                <th rds-header-cell *rdsHeaderCellDef class="required">
                  {{
                    OFFERING_FORM.FUNCTIONALITY.CAPABILITIES.TABLE_COLUMNS
                      .CAPABILITY_BENEFIT
                  }}
                </th>
                <td class="last-column" rds-cell *rdsCellDef="let element">
                  <span>{{ element.benefit }}</span>
                  <div rdsDropdown class="options" autofocusFirstItem>
                    <button
                      rds-dropdown-toggle-icon-button
                      aria-label="More options"
                      type="button"
                    >
                      <rds-icon namespace="outlined" icon="more_vertical" />
                    </button>
                    <div *rdsDropdownMenu>
                      <ul rds-list-item-container>
                        <li>
                          <button
                            rds-list-item
                            (click)="handleCapabilityDialog(element)"
                          >
                            {{ BUTTONS.EDIT }}
                          </button>
                        </li>
                        <li>
                          <button
                            rds-list-item
                            (click)="handleDeleteCapability(element)"
                          >
                            {{ BUTTONS.DELETE }}
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </td>
              </ng-container>

              <tr rds-header-row *rdsHeaderRowDef="capabilityColumns"></tr>
              <tr rds-row *rdsRowDef="let row; columns: capabilityColumns"></tr>
            </table>

            <button
              class="table-action"
              rds-text-button
              (click)="handleCapabilityDialog()"
            >
              <rds-icon icon="plus" namespace="filled" />
              {{ OFFERING_FORM.FUNCTIONALITY.CAPABILITIES.CTA }}
            </button>
          </fieldset>
          <fieldset class="form-box" aria-labelledby="offering-use-case-title">
            <h3 class="ui-heading-3-bold mb-5" id="offering-use-case-title">
              {{ OFFERING_FORM.FUNCTIONALITY.USE_CASES.SECTION_TITLE }}
            </h3>

            <p class="ui-body-s-bold">
              {{ OFFERING_FORM.FUNCTIONALITY.USE_CASES.HINT }}
            </p>
            <table
              rds-table
              [dataSource]="useCaseDataSource"
              alternation="vertical"
            >
              <ng-container rdsColumnDef="name">
                <th rds-header-cell *rdsHeaderCellDef class="required">
                  {{
                    OFFERING_FORM.FUNCTIONALITY.USE_CASES.TABLE_COLUMNS
                      .USE_CASE_NAME
                  }}
                </th>
                <td rds-cell *rdsCellDef="let element">
                  {{ element.name }}
                </td>
              </ng-container>

              <ng-container rdsColumnDef="description">
                <th rds-header-cell *rdsHeaderCellDef class="required">
                  {{
                    OFFERING_FORM.FUNCTIONALITY.USE_CASES.TABLE_COLUMNS
                      .USE_CASE_DESCRIPTION
                  }}
                </th>
                <td class="last-column" rds-cell *rdsCellDef="let element">
                  <span>{{ element.description }}</span>
                  <div rdsDropdown class="options" autofocusFirstItem>
                    <button
                      rds-dropdown-toggle-icon-button
                      aria-label="More options"
                      type="button"
                    >
                      <rds-icon namespace="outlined" icon="more_vertical" />
                    </button>
                    <div *rdsDropdownMenu>
                      <ul rds-list-item-container>
                        <li>
                          <button
                            rds-list-item
                            (click)="handleUseCaseDialog(element)"
                          >
                            {{ BUTTONS.EDIT }}
                          </button>
                        </li>
                        <li>
                          <button
                            rds-list-item
                            (click)="handleDeleteUseCase(element)"
                          >
                            {{ BUTTONS.DELETE }}
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </td>
              </ng-container>

              <tr rds-header-row *rdsHeaderRowDef="useCaseColumns"></tr>
              <tr rds-row *rdsRowDef="let row; columns: useCaseColumns"></tr>
            </table>

            <button
              class="table-action"
              rds-text-button
              (click)="handleUseCaseDialog()"
            >
              <rds-icon icon="plus" namespace="filled" />
              {{ OFFERING_FORM.FUNCTIONALITY.USE_CASES.CTA }}
            </button>
          </fieldset>
        </form>
        <div class="form-actions">
          <button rds-secondary-button rdsStepperPrevious size="l">
            {{ BUTTONS.PREVIOUS_STEP }}
          </button>
          <div class="publish-and-next">
            @if (offeringUUID()) {
              <button
                rds-secondary-button
                (click)="handlePublish()"
                size="l"
                [disabled]="isPublishing()"
              >
                @if (isPublishing()) {
                  <div class="loading-container">
                    <rds-progress-spinner
                      class="loading-spinner"
                    ></rds-progress-spinner>
                    {{ BUTTONS.PUBLISHING }}
                  </div>
                } @else {
                  {{ BUTTONS.PUBLISH }}
                }
              </button>
            }
            <button rds-primary-button rdsStepperNext size="l">
              {{ BUTTONS.NEXT_STEP }}
            </button>
          </div>
        </div>
      </rds-step>

      <!-- 5 -->
      <rds-step label="step_5_summary" optional>
        <ng-template rdsStepLabel>{{ OFFERING_FORM.STEPS.STEP_5 }}</ng-template>
        <div class="form">
          <section class="form-box">
            <div class="summary-bar">
              <h3 class="ui-heading-3-bold">
                {{ OFFERING_FORM.STEPS.STEP_1 }}
              </h3>
              <button rds-text-button size="l" (click)="goTo(0)">
                <rds-icon icon="edit" namespace="filled" />
                {{ BUTTONS.EDIT }}
              </button>
            </div>

            <div class="summary-container">
              <section
                class="summary-pair"
                [class.has-error]="hasError(formPermissions, 'ownerEmail')"
              >
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.PERMISSIONS.OWNER.LABEL }}
                </p>
                <div class="ui-label-l">
                  {{ summary().permissions.ownerEmail || "—" }}
                </div>
              </section>

              <section
                class="summary-pair"
                [class.has-error]="hasError(formPermissions, 'deputyEmail')"
              >
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.PERMISSIONS.DEPUTY.LABEL }}
                </p>
                <div class="ui-label-l">
                  {{ summary().permissions.deputyEmail || "—" }}
                </div>
              </section>

              <section
                class="summary-pair"
                [class.has-error]="hasError(formPermissions, 'authorEmails')"
              >
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.PERMISSIONS.AUTHOR.LABEL }}
                </p>
                <div class="ui-label-l">
                  @if (summary().permissions.authorEmails) {
                    @for (
                      a of summary().permissions.authorEmails;
                      track $index;
                      let last = $last
                    ) {
                      {{ a || "—" }}
                      @if (!last) {
                        ,
                      }
                    }
                  } @else {
                    —
                  }
                </div>
              </section>
            </div>
          </section>

          <section class="form-box">
            <div class="summary-bar">
              <h3 class="ui-heading-3-bold">
                {{ OFFERING_FORM.STEPS.STEP_2 }}
              </h3>
              <button rds-text-button size="l" (click)="goTo(1)">
                <rds-icon icon="edit" namespace="filled" />
                {{ BUTTONS.EDIT }}
              </button>
            </div>

            <div class="summary-container">
              <section
                class="summary-pair"
                [class.has-error]="hasError(formOverview, 'displayName')"
              >
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.OVERVIEW.GENERAL_INFO.DISPLAY_NAME.LABEL }}
                </p>
                <div class="ui-label-l">
                  {{ summary().overview.displayName || "—" }}
                </div>
              </section>

              <section
                class="summary-pair"
                [class.has-error]="hasError(formOverview, 'approvalStatus')"
              >
                <p class="ui-label-m-bold">
                  {{
                    OFFERING_FORM.OVERVIEW.GENERAL_INFO.APPROVAL_STATUS.LABEL
                  }}
                </p>
                <div class="ui-label-l">
                  {{ summary().overview.approvalStatus || "—" }}
                </div>
              </section>

              <section class="summary-pair">
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.OVERVIEW.GENERAL_INFO.SUCCESSOR.LABEL }}
                </p>
                <p class="ui-label-l">
                  {{
                    getOfferingById()(summary().overview.successor)
                      ?.displayName || "—"
                  }}
                </p>
              </section>

              <section
                class="summary-pair"
                [class.has-error]="hasError(formOverview, 'description')"
              >
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.OVERVIEW.DESCRIPTION.LABEL }}
                </p>
                <p class="ui-label-l">
                  {{ summary().overview.description || "—" }}
                </p>
              </section>
              <section
                  class="summary-pair"
                  [class.has-error]="hasError(formOverview, 'relationshipType')"
                >
                  <p class="ui-label-m-bold">
                    {{
                      OFFERING_FORM.OVERVIEW.OFFERING_RELATIONSHIP
                        .RELATIONSHIP_TYPE.LABEL
                    }}
                  </p>
                  <p class="ui-label-l">
                    {{ summary().overview.relationshipType || "—" }}
                  </p>
                </section>
                @if (summary().overview.relationshipType) {
                  <section class="summary-pair">
                    <p class="ui-label-m-bold">
                      {{
                        summary().overview.relationshipType ===
                        OfferingRelationshipType.CHILD_OF
                          ? OFFERING_FORM.OVERVIEW.OFFERING_RELATIONSHIP
                              .SELECT_PARENT.LABEL
                          : OFFERING_FORM.OVERVIEW.OFFERING_RELATIONSHIP
                              .SELECT_CHILD.LABEL
                      }}
                    </p>
                    <p class="ui-label-l">
                      {{
                        getOfferingById()(
                          summary().overview.relationshipTargetOfferingId
                        )?.displayName || "—"
                      }}
                    </p>
                  </section>
                }
              <section class="summary-pair">
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.OVERVIEW.SIMILAR_OFFERINGS.LABEL }}
                </p>
                <p class="ui-label-l">
                  {{ similarOfferingsDisplay() }}
                </p>
              </section>
            </div>
          </section>

          <section class="form-box">
            <div class="summary-bar">
              <h3 class="ui-heading-3-bold">
                {{ OFFERING_FORM.STEPS.STEP_3 }}
              </h3>
              <button rds-text-button size="l" (click)="goTo(2)">
                <rds-icon icon="edit" namespace="filled" />
                Edit
              </button>
            </div>

            <div class="summary-container">
              <section
                class="summary-pair"
                [class.has-error]="
                  hasError(formDetails, 'onboardingAccessInstructions')
                "
              >
                <p class="ui-label-m-bold">
                  {{
                    OFFERING_FORM.DETAILS.ONBOARDING.ACCESS_INSTRUCTIONS.LABEL
                  }}
                </p>
                <p class="ui-label-l">
                  {{ summary().details.onboardingAccessInstructions || "—" }}
                </p>
              </section>

              <section
                class="summary-pair"
                [class.has-error]="onboardingSteps().length === 0"
              >
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.DETAILS.ONBOARDING.LABEL }}
                </p>
                <table
                  rds-table
                  [dataSource]="onboardingDataSource"
                  alternation="vertical"
                >
                  <ng-container rdsColumnDef="description">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{
                        OFFERING_FORM.DETAILS.ONBOARDING.TABLE_COLUMNS
                          .STEP_DESCRIPTION
                      }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      {{ element.description }}
                    </td>
                  </ng-container>

                  <ng-container rdsColumnDef="referenceUrl">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{
                        OFFERING_FORM.DETAILS.ONBOARDING.TABLE_COLUMNS
                          .ACCESS_URL
                      }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      {{ element.referenceUrl }}
                    </td>
                  </ng-container>

                  <tr rds-header-row *rdsHeaderRowDef="onboardingColumns"></tr>
                  <tr
                    rds-row
                    *rdsRowDef="let row; columns: onboardingColumns"
                  ></tr>
                </table>
              </section>

              <section
                class="summary-pair"
                [class.has-error]="servicesAndRequests().length === 0"
              >
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.DETAILS.SERVICE_AND_REQUEST.SECTION_TITLE }}
                </p>
                <table
                  rds-table
                  [dataSource]="serviceAndRequestDataSource"
                  alternation="vertical"
                >
                  <ng-container rdsColumnDef="type">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{
                        OFFERING_FORM.DETAILS.SERVICE_AND_REQUEST.TABLE_COLUMNS
                          .TYPE
                      }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      {{ element.type }}
                    </td>
                  </ng-container>

                  <ng-container rdsColumnDef="title">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{
                        OFFERING_FORM.DETAILS.SERVICE_AND_REQUEST.TABLE_COLUMNS
                          .TITLE
                      }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      {{ element.title }}
                    </td>
                  </ng-container>

                  <ng-container rdsColumnDef="destinationValue">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{
                        OFFERING_FORM.DETAILS.SERVICE_AND_REQUEST.TABLE_COLUMNS
                          .DESTINATION
                      }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      {{ element.destinationValue }}
                    </td>
                  </ng-container>

                  <ng-container rdsColumnDef="description">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{
                        OFFERING_FORM.DETAILS.SERVICE_AND_REQUEST.TABLE_COLUMNS
                          .DESCRIPTION
                      }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      {{ element.description }}
                    </td>
                  </ng-container>



                  <tr
                    rds-header-row
                    *rdsHeaderRowDef="serviceAndRequestColumns"
                  ></tr>
                  <tr
                    rds-row
                    *rdsRowDef="let row; columns: serviceAndRequestColumns"
                  ></tr>
                </table>
              </section>

              <section
                class="summary-pair"
                [class.has-error]="
                  hasError(formDetails, 'licenseCostResponsibility')
                "
              >
                <p class="ui-label-m-bold">
                  {{
                    OFFERING_FORM.DETAILS.LICENSE.LICENSE_COST_RESPONSIBILITY
                      .LABEL
                  }}
                </p>
                <p class="ui-label-l">
                  {{ summary().details.licenseCostResponsibility || "—" }}
                </p>
              </section>

              <section class="summary-pair">
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.DETAILS.LICENSE.PRICING_PER_USER.LABEL }}
                </p>
                @if (
                  typeof summary().details.isPerUserPricingAvailable ===
                  "boolean"
                ) {
                  <p class="ui-label-l">
                    {{
                      summary().details.isPerUserPricingAvailable ? "Yes" : "No"
                    }}
                  </p>
                } @else {
                  <p class="ui-label-l">—</p>
                }
              </section>

              <section
                class="summary-pair"
                [class.has-error]="hasError(formDetails, 'perUserCostValue')"
              >
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.DETAILS.LICENSE.VALUE.LABEL }}
                </p>
                <p class="ui-label-l">
                  {{ summary().details.perUserCostValue || "—" }}
                </p>
              </section>

              <section
                class="summary-pair"
                [class.has-error]="hasError(formDetails, 'perUserCostCurrency')"
              >
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.DETAILS.LICENSE.CURRENCY.LABEL }}
                </p>
                <p class="ui-label-l">
                  {{ summary().details.perUserCostCurrency || "—" }}
                </p>
              </section>

              <section
                class="summary-pair"
                [class.has-error]="
                  hasError(formDetails, 'perUserCostFrequency')
                "
              >
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.DETAILS.LICENSE.PAYMENT_FREQUENCY.LABEL }}
                </p>
                <p class="ui-label-l">
                  {{ summary().details.perUserCostFrequency || "—" }}
                </p>
              </section>

              <section
                class="summary-pair"
                [class.has-error]="
                  hasError(formDetails, 'developmentCostResponsibility')
                "
              >
                <p class="ui-label-m-bold">
                  {{
                    OFFERING_FORM.DETAILS.DEVELOPMENT_COST.RESPONSIBILITY.LABEL
                  }}
                </p>
                <p class="ui-label-l">
                  {{ summary().details.developmentCostResponsibility || "—" }}
                </p>
              </section>

              <section class="summary-pair">
                <p class="ui-label-m-bold">
                  {{
                    OFFERING_FORM.DETAILS.DEVELOPMENT_COST.OTHER_DETAILS.LABEL
                  }}
                </p>
                <p class="ui-label-l">
                  {{
                    summary().details
                      .developmentCostResponsibilityOtherDetails || "—"
                  }}
                </p>
              </section>

              <section class="summary-pair">
                <p
                  class="ui-label-m-bold"
                  [class.has-error]="
                    hasError(
                      formDetails,
                      'supportMaintenanceCostResponsibility'
                    )
                  "
                >
                  {{
                    OFFERING_FORM.DETAILS.SUPPORT_MAINTENANCE_COST
                      .RESPONSIBILITY.LABEL
                  }}
                </p>
                <p class="ui-label-l">
                  {{
                    summary().details.supportMaintenanceCostResponsibility ||
                      "—"
                  }}
                </p>
              </section>

              <section class="summary-pair">
                <p class="ui-label-m-bold">
                  {{
                    OFFERING_FORM.DETAILS.SUPPORT_MAINTENANCE_COST.OTHER_DETAILS
                      .LABEL
                  }}
                </p>
                <p class="ui-label-l">
                  {{
                    summary().details
                      .supportMaintenanceCostResponsibilityOtherDetails || "—"
                  }}
                </p>
              </section>

              <section
                class="summary-pair"
                [class.has-error]="hasError(formDetails, 'isSupported')"
              >
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.DETAILS.SUPPORT.AVAILABILITY.LABEL }}
                </p>
                @if (typeof summary().details.isSupported === "boolean") {
                  <p class="ui-label-l">
                    {{
                      summary().details.isSupported
                        ? "Supported"
                        : "Not Supported"
                    }}
                  </p>
                } @else {
                  <p class="ui-label-l">—</p>
                }
              </section>

              @if (summary().details.isSupported) {
               <section
                  class="summary-pair"
                  [class.has-error]="supportChannels().length === 0"
                >
                  <p class="ui-label-m-bold">
                    {{ OFFERING_FORM.DETAILS.SUPPORT.CHANNEL.LABEL }}
                  </p>
                  <table
                    rds-table
                    [dataSource]="supportChannelDataSource"
                    alternation="vertical"
                  >
                    <ng-container rdsColumnDef="channelType">
                      <th rds-header-cell *rdsHeaderCellDef>
                        {{
                          OFFERING_FORM.DETAILS.SUPPORT.CHANNEL.TABLE_COLUMNS
                            .CHANNEL_TYPE
                        }}
                      </th>
                      <td rds-cell *rdsCellDef="let element">
                        {{ element.channelType }}
                      </td>
                    </ng-container>

                    <ng-container rdsColumnDef="destinationValue">
                      <th rds-header-cell *rdsHeaderCellDef>
                        {{
                          OFFERING_FORM.DETAILS.SUPPORT.CHANNEL.TABLE_COLUMNS
                            .DESTINATION
                        }}
                      </th>
                      <td rds-cell *rdsCellDef="let element">
                        {{ element.destinationValue }}
                      </td>
                    </ng-container>

                    <ng-container rdsColumnDef="description">
                      <th rds-header-cell *rdsHeaderCellDef>
                        {{
                          OFFERING_FORM.DETAILS.SUPPORT.CHANNEL.TABLE_COLUMNS
                            .DESCRIPTION
                        }}
                      </th>
                      <td rds-cell *rdsCellDef="let element">
                        {{ element.description }}
                      </td>
                    </ng-container>

                    <ng-container rdsColumnDef="serviceDeskName">
                      <th rds-header-cell *rdsHeaderCellDef>
                        {{
                          OFFERING_FORM.DETAILS.SUPPORT.CHANNEL.TABLE_COLUMNS
                            .SERVICE_DESK_NAME
                        }}
                      </th>
                      <td rds-cell *rdsCellDef="let element">
                        {{ element.serviceDeskName }}
                      </td>
                    </ng-container>

                    <tr
                      rds-header-row
                      *rdsHeaderRowDef="supportChannelColumns"
                    ></tr>
                    <tr
                      rds-row
                      *rdsRowDef="let row; columns: supportChannelColumns"
                    ></tr>
                  </table>
                </section>

                <section
                  class="summary-pair"
                  [class.has-error]="supportHours().length === 0"
                >
                  <p class="ui-label-m-bold">
                    {{ OFFERING_FORM.DETAILS.SUPPORT.HOUR.LABEL }}
                  </p>
                  <table
                    rds-table
                    [dataSource]="supportHourDataSource"
                    alternation="vertical"
                  >
                    <ng-container rdsColumnDef="days">
                      <th rds-header-cell *rdsHeaderCellDef>
                        {{
                          OFFERING_FORM.DETAILS.SUPPORT.HOUR.TABLE_COLUMNS.DAYS
                        }}
                      </th>
                      <td rds-cell *rdsCellDef="let element">
                        {{ element.days?.join(", ") }}
                      </td>
                    </ng-container>

                    <ng-container rdsColumnDef="startTime">
                      <th rds-header-cell *rdsHeaderCellDef>
                        {{
                          OFFERING_FORM.DETAILS.SUPPORT.HOUR.TABLE_COLUMNS
                            .START_TIME
                        }}
                      </th>
                      <td rds-cell *rdsCellDef="let element">
                        {{ element.startTime | date: "shortTime" }}
                      </td>
                    </ng-container>

                    <ng-container rdsColumnDef="endTime">
                      <th rds-header-cell *rdsHeaderCellDef>
                        {{
                          OFFERING_FORM.DETAILS.SUPPORT.HOUR.TABLE_COLUMNS
                            .END_TIME
                        }}
                      </th>
                      <td rds-cell *rdsCellDef="let element">
                        {{ element.endTime | date: "shortTime" }}
                      </td>
                    </ng-container>

                    <ng-container rdsColumnDef="timezone">
                      <th rds-header-cell *rdsHeaderCellDef>
                        {{
                          OFFERING_FORM.DETAILS.SUPPORT.HOUR.TABLE_COLUMNS
                            .TIMEZONE
                        }}
                      </th>
                      <td rds-cell *rdsCellDef="let element">
                        {{ element.timezone }}
                      </td>
                    </ng-container>

                    <ng-container rdsColumnDef="responseTime">
                      <th rds-header-cell *rdsHeaderCellDef>
                        {{
                          OFFERING_FORM.DETAILS.SUPPORT.HOUR.TABLE_COLUMNS
                            .RESPONSE_TIME
                        }}
                      </th>
                      <td rds-cell *rdsCellDef="let element">
                        {{ element.responseTime }}
                      </td>
                    </ng-container>

                    <tr
                      rds-header-row
                      *rdsHeaderRowDef="supportHourColumns"
                    ></tr>
                    <tr
                      rds-row
                      *rdsRowDef="let row; columns: supportHourColumns"
                    ></tr>
                  </table>
                </section>
              }

              <section
                class="summary-pair"
                [class.has-error]="environments().length === 0"
              >
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.DETAILS.ENVIRONMENT.SECTION_TITLE }}
                </p>
                <table
                  rds-table
                  [dataSource]="environmentDataSource"
                  alternation="vertical"
                >
                  <ng-container rdsColumnDef="name">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{ OFFERING_FORM.DETAILS.ENVIRONMENT.TABLE_COLUMNS.NAME }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      {{ element.name }}
                    </td>
                  </ng-container>

                  <ng-container rdsColumnDef="url">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{ OFFERING_FORM.DETAILS.ENVIRONMENT.TABLE_COLUMNS.URL }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      {{ element.url }}
                    </td>
                  </ng-container>

                  <ng-container rdsColumnDef="serviceLevelAgreement">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{ OFFERING_FORM.DETAILS.ENVIRONMENT.TABLE_COLUMNS.SLA }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      {{ element.serviceLevelAgreement }}
                    </td>
                  </ng-container>

                  <tr rds-header-row *rdsHeaderRowDef="environmentColumns"></tr>
                  <tr
                    rds-row
                    *rdsRowDef="let row; columns: environmentColumns"
                  ></tr>
                </table>
              </section>

              <section
                class="summary-pair"
                [class.has-error]="hasError(formDetails, 'vendorName')"
              >
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.DETAILS.VENDOR.NAME.LABEL }}
                </p>
                <p class="ui-label-l">
                  {{ summary().details.vendorName || "—" }}
                </p>
              </section>

              <section class="summary-pair">
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.DETAILS.VENDOR.SUPPORT.LABEL }}
                </p>
                <p class="ui-label-l">
                  {{ summary().details.vendorSupport || "—" }}
                </p>
              </section>

              <section class="summary-pair">
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.DETAILS.VENDOR.URL.LABEL }}
                </p>
                <p class="ui-label-l">
                  {{ summary().details.vendorUrl || "—" }}
                </p>
              </section>

              <section
                class="summary-pair"
                [class.has-error]="
                  hasError(formDetails, 'isExternalUseAllowed')
                "
              >
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.DETAILS.EXTERNAL_USE.LABEL }}
                </p>
                @if (
                  typeof summary().details.isExternalUseAllowed === "boolean"
                ) {
                  <p class="ui-label-l">
                    {{ summary().details.isExternalUseAllowed ? "Yes" : "No" }}
                  </p>
                } @else {
                  <p class="ui-label-l">—</p>
                }
              </section>

              <section class="summary-pair">
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.DETAILS.AVAILABLE_VERSION.SECTION_TITLE }}
                </p>
                <table
                  rds-table
                  [dataSource]="availableVersionDataSource"
                  alternation="vertical"
                >
                  <ng-container rdsColumnDef="version">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{
                        OFFERING_FORM.DETAILS.AVAILABLE_VERSION.TABLE_COLUMNS
                          .VERSION
                      }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      {{ element.version }}
                    </td>
                  </ng-container>

                  <ng-container rdsColumnDef="status">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{
                        OFFERING_FORM.DETAILS.AVAILABLE_VERSION.TABLE_COLUMNS
                          .STATUS
                      }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      {{ element.status }}
                    </td>
                  </ng-container>

                  <ng-container rdsColumnDef="compatibility">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{
                        OFFERING_FORM.DETAILS.AVAILABLE_VERSION.TABLE_COLUMNS
                          .COMPATIBILITY
                      }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      {{ element.compatibility }}
                    </td>
                  </ng-container>

                  <ng-container rdsColumnDef="releaseDate">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{
                        OFFERING_FORM.DETAILS.AVAILABLE_VERSION.TABLE_COLUMNS
                          .RELEASE_DATE
                      }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      {{ element.releaseDate }}
                    </td>
                  </ng-container>

                  <ng-container rdsColumnDef="endOfLifeDate">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{
                        OFFERING_FORM.DETAILS.AVAILABLE_VERSION.TABLE_COLUMNS
                          .END_OF_LIFE_DATE
                      }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      {{ element.endOfLifeDate }}
                    </td>
                  </ng-container>

                  <ng-container rdsColumnDef="additionalInfo">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{
                        OFFERING_FORM.DETAILS.AVAILABLE_VERSION.TABLE_COLUMNS
                          .ADDITIONAL_INFORMATION
                      }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      {{ element.additionalInfo }}
                    </td>
                  </ng-container>

                  <tr
                    rds-header-row
                    *rdsHeaderRowDef="availableVersionColumns"
                  ></tr>
                  <tr
                    rds-row
                    *rdsRowDef="let row; columns: availableVersionColumns"
                  ></tr>
                </table>
              </section>

              <section class="summary-pair">
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.DETAILS.ADDONS.CHECKBOX_LABEL }}
                </p>
                <p class="ui-label-l">
                  {{ summary().details.hasAddons ? "Yes" : "No" }}
                </p>
              </section>

              @if (summary().details.hasAddons) {
                <section class="summary-pair">
                  <p class="ui-label-m-bold">
                    {{ OFFERING_FORM.DETAILS.ADDONS.TABLE_LABEL }}
                  </p>
                  <table
                    rds-table
                    [dataSource]="addonDataSource"
                    alternation="vertical"
                  >
                    <ng-container rdsColumnDef="name">
                      <th rds-header-cell *rdsHeaderCellDef>
                        {{ OFFERING_FORM.DETAILS.ADDONS.TABLE_COLUMNS.NAME }}
                      </th>
                      <td rds-cell *rdsCellDef="let element">
                        {{ element.name }}
                      </td>
                    </ng-container>

                    <ng-container rdsColumnDef="description">
                      <th rds-header-cell *rdsHeaderCellDef>
                        {{
                          OFFERING_FORM.DETAILS.ADDONS.TABLE_COLUMNS.DESCRIPTION
                        }}
                      </th>
                      <td rds-cell *rdsCellDef="let element">
                        {{ element.description }}
                      </td>
                    </ng-container>

                    <ng-container rdsColumnDef="cost">
                      <th rds-header-cell *rdsHeaderCellDef>
                        {{ OFFERING_FORM.DETAILS.ADDONS.TABLE_COLUMNS.COST }}
                      </th>
                      <td rds-cell *rdsCellDef="let element">
                        {{ element.cost }}
                      </td>
                    </ng-container>

                    <ng-container rdsColumnDef="support">
                      <th rds-header-cell *rdsHeaderCellDef>
                        {{ OFFERING_FORM.DETAILS.ADDONS.TABLE_COLUMNS.SUPPORT }}
                      </th>
                      <td rds-cell *rdsCellDef="let element">
                        {{ element.support ? "Yes" : "No" }}
                      </td>
                    </ng-container>

                    <ng-container rdsColumnDef="url">
                      <th rds-header-cell *rdsHeaderCellDef>
                        {{ OFFERING_FORM.DETAILS.ADDONS.TABLE_COLUMNS.URL }}
                      </th>
                      <td rds-cell *rdsCellDef="let element">
                        {{ element.url }}
                      </td>
                    </ng-container>

                    <tr rds-header-row *rdsHeaderRowDef="addonColumns"></tr>
                    <tr
                      rds-row
                      *rdsRowDef="let row; columns: addonColumns"
                    ></tr>
                  </table>
                </section>
              }

              <section class="summary-pair">
                <p class="ui-label-m-bold">
                  {{
                    OFFERING_FORM.DETAILS.ADDITIONAL_COST
                      .ADDITIONAL_COST_CONSIDERATIONS.CHECKBOX_LABEL
                  }}
                </p>
                <p class="ui-label-l">
                  {{
                    summary().details.isAdditionalCostConsiderationsAvailable
                      ? "Yes"
                      : "No"
                  }}
                </p>
              </section>

              @if (summary().details.isAdditionalCostConsiderationsAvailable) {
                <section
                  class="summary-pair"
                  [class.has-error]="
                    hasError(formDetails, 'additionalCostConsiderations')
                  "
                >
                  <p class="ui-label-m-bold">
                    {{
                      OFFERING_FORM.DETAILS.ADDITIONAL_COST
                        .ADDITIONAL_COST_CONSIDERATIONS.LABEL
                    }}
                  </p>
                  <p class="ui-label-l">
                    {{ summary().details.additionalCostConsiderations || "—" }}
                  </p>
                </section>
              }

              <section class="summary-pair">
                <p class="ui-label-m-bold">
                  {{
                    OFFERING_FORM.DETAILS.ADDITIONAL_COST.OTHER_PRICING_MODELS
                      .CHECKBOX_LABEL
                  }}
                </p>
                <p class="ui-label-l">
                  {{
                    summary().details.isOtherPricingModelsAvailable
                      ? "Yes"
                      : "No"
                  }}
                </p>
              </section>

              @if (summary().details.isOtherPricingModelsAvailable) {
                <section
                  class="summary-pair"
                  [class.has-error]="
                    hasError(formDetails, 'otherPricingModels')
                  "
                >
                  <p class="ui-label-m-bold">
                    {{
                      OFFERING_FORM.DETAILS.ADDITIONAL_COST.OTHER_PRICING_MODELS
                        .LABEL
                    }}
                  </p>
                  <p class="ui-label-l">
                    {{ summary().details.otherPricingModels || "—" }}
                  </p>
                </section>
              }

              <section class="summary-pair">
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.DETAILS.COMMUNITY.SECTION_TITLE }}
                </p>
                <table
                  rds-table
                  [dataSource]="communityDataSource"
                  alternation="vertical"
                >
                  <ng-container rdsColumnDef="title">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{ OFFERING_FORM.DETAILS.COMMUNITY.TABLE_COLUMNS.NAME }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      {{ element.title }}
                    </td>
                  </ng-container>

                  <ng-container rdsColumnDef="description">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{
                        OFFERING_FORM.DETAILS.COMMUNITY.TABLE_COLUMNS
                          .DESCRIPTION
                      }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      {{ element.description }}
                    </td>
                  </ng-container>

                  <ng-container rdsColumnDef="url">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{ OFFERING_FORM.DETAILS.COMMUNITY.TABLE_COLUMNS.URL }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      {{ element.url }}
                    </td>
                  </ng-container>

                  <tr rds-header-row *rdsHeaderRowDef="communityColumns"></tr>
                  <tr
                    rds-row
                    *rdsRowDef="let row; columns: communityColumns"
                  ></tr>
                </table>
              </section>

              <section class="summary-pair">
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.DETAILS.HOSTING.SECTION_TITLE }}
                </p>
                <table
                  rds-table
                  [dataSource]="hostingDataSource"
                  alternation="vertical"
                >
                  <ng-container rdsColumnDef="name">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{ OFFERING_FORM.DETAILS.HOSTING.TABLE_COLUMNS.NAME }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      {{ element.name }}
                    </td>
                  </ng-container>

                  <ng-container rdsColumnDef="type">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{ OFFERING_FORM.DETAILS.HOSTING.TABLE_COLUMNS.TYPE }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      {{ element.type }}
                    </td>
                  </ng-container>

                  <ng-container rdsColumnDef="managed">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{ OFFERING_FORM.DETAILS.HOSTING.TABLE_COLUMNS.MANAGED }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      {{ element.managed }}
                    </td>
                  </ng-container>

                  <tr rds-header-row *rdsHeaderRowDef="hostingColumns"></tr>
                  <tr
                    rds-row
                    *rdsRowDef="let row; columns: hostingColumns"
                  ></tr>
                </table>
              </section>

              <section class="summary-pair">
                <p class="ui-label-m-bold">
                  Is an SRA required for solutions built on this platform?
                </p>
                <p class="ui-label-l">
                  {{ summary().details.isSraRequired ? "Yes" : "No" }}
                </p>
              </section>

              <section
                class="summary-pair"
                [class.has-error]="
                  hasError(formDetails, 'systemRiskAssessmentName')
                "
              >
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.DETAILS.SRA.ASSESSMENT_ID.LABEL }}
                </p>
                <p class="ui-label-l">
                  {{ summary().details.systemRiskAssessmentName || "—" }}
                </p>
              </section>

              <section class="summary-pair">
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.DETAILS.SRA.DATA_CONFIDENTIALITY.LABEL }}
                </p>
                <p class="ui-label-l">
                  {{ summary().details.classificationLevel || "—" }}
                </p>
              </section>

              <section class="summary-pair">
                <p class="ui-label-m-bold">
                  {{
                    OFFERING_FORM.DETAILS.SUPPORTED_DATA_CLASSIFICATION
                      .CLASSIFICATION_LEVEL.LABEL
                  }}
                </p>
                <p class="ui-label-l">
                  {{
                    summary().details.supportedDataClassificationLevel || "—"
                  }}
                </p>
              </section>

              <section class="summary-pair">
                <p class="ui-label-m-bold">
                  {{
                    OFFERING_FORM.DETAILS.SUPPORTED_DATA_CLASSIFICATION
                      .ADDITIONAL_INFORMATION.LABEL
                  }}
                </p>
                <p class="ui-label-l">
                  {{
                    summary().details
                      .supportedDataClassificationAdditionalInformation || "—"
                  }}
                </p>
              </section>

              <section class="summary-pair">
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.DETAILS.SSO.SUPPORT.CHECKBOX_LABEL }}
                </p>
                @if (
                  typeof summary().details.isSingleSignOnSupported === "boolean"
                ) {
                  <p class="ui-label-l">
                    {{
                      summary().details.isSingleSignOnSupported ? "Yes" : "No"
                    }}
                  </p>
                } @else {
                  <p class="ui-label-l">—</p>
                }
              </section>

              <section
                class="summary-pair"
                [class.has-error]="
                  summary().details.isSingleSignOnSupported &&
                  hasError(formDetails, 'singleSignOnProviders')
                "
              >
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.DETAILS.SSO.PROVIDER.LABEL }}
                </p>
                <p class="ui-label-l">
                  {{ summary().details.singleSignOnProviders || "—" }}
                </p>
              </section>

              <section class="summary-pair">
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.DETAILS.AI_AGENT.SECTION_TITLE }}
                </p>
                <table
                  rds-table
                  [dataSource]="agentDataSource"
                  alternation="vertical"
                >
                  <ng-container rdsColumnDef="name">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{ OFFERING_FORM.DETAILS.AI_AGENT.TABLE_COLUMNS.NAME }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      {{ element.name }}
                    </td>
                  </ng-container>

                  <ng-container rdsColumnDef="url">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{ OFFERING_FORM.DETAILS.AI_AGENT.TABLE_COLUMNS.URL }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      {{ element.url }}
                    </td>
                  </ng-container>

                  <tr rds-header-row *rdsHeaderRowDef="agentColumns"></tr>
                  <tr rds-row *rdsRowDef="let row; columns: agentColumns"></tr>
                </table>
              </section>
            </div>
          </section>

          <section class="form-box">
            <div class="summary-bar">
              <h3 class="ui-heading-3-bold">
                {{ OFFERING_FORM.STEPS.STEP_4 }}
              </h3>
              <button rds-text-button size="l" (click)="goTo(3)">
                <rds-icon icon="edit" namespace="filled" />
                {{ BUTTONS.EDIT }}
              </button>
            </div>

            <div class="summary-container">
              <section
                class="summary-pair"
                [class.has-error]="features().length === 0"
              >
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.FUNCTIONALITY.FEATURES.SECTION_TITLE }}
                </p>
                <table
                  rds-table
                  [dataSource]="featureDataSource"
                  alternation="vertical"
                >
                  <ng-container rdsColumnDef="name">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{
                        OFFERING_FORM.FUNCTIONALITY.FEATURES.TABLE_COLUMNS
                          .FEATURE_NAME
                      }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      {{ element.name }}
                    </td>
                  </ng-container>

                  <ng-container rdsColumnDef="description">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{
                        OFFERING_FORM.FUNCTIONALITY.FEATURES.TABLE_COLUMNS
                          .FEATURE_DESCRIPTION
                      }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      <span>{{ element.description }}</span>
                    </td>
                  </ng-container>

                  <ng-container rdsColumnDef="benefit">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{
                        OFFERING_FORM.FUNCTIONALITY.FEATURES.TABLE_COLUMNS
                          .FEATURE_BENEFIT
                      }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      <span>{{ element.benefit }}</span>
                    </td>
                  </ng-container>
                  <tr rds-header-row *rdsHeaderRowDef="featureColumns"></tr>
                  <tr
                    rds-row
                    *rdsRowDef="let row; columns: featureColumns"
                  ></tr>
                </table>
              </section>

              <section
                class="summary-pair"
                [class.has-error]="capabilities().length === 0"
              >
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.FUNCTIONALITY.CAPABILITIES.SECTION_TITLE }}
                </p>
                <table
                  rds-table
                  [dataSource]="capabilityDataSource"
                  alternation="vertical"
                >
                  <ng-container rdsColumnDef="name">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{
                        OFFERING_FORM.FUNCTIONALITY.CAPABILITIES.TABLE_COLUMNS
                          .CAPABILITY_NAME
                      }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      {{ element.name }}
                    </td>
                  </ng-container>

                  <ng-container rdsColumnDef="description">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{
                        OFFERING_FORM.FUNCTIONALITY.CAPABILITIES.TABLE_COLUMNS
                          .CAPABILITY_DESCRIPTION
                      }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      <span>{{ element.description }}</span>
                    </td>
                  </ng-container>

                  <ng-container rdsColumnDef="benefit">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{
                        OFFERING_FORM.FUNCTIONALITY.CAPABILITIES.TABLE_COLUMNS
                          .CAPABILITY_BENEFIT
                      }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      <span>{{ element.benefit }}</span>
                    </td>
                  </ng-container>
                  <tr rds-header-row *rdsHeaderRowDef="capabilityColumns"></tr>
                  <tr
                    rds-row
                    *rdsRowDef="let row; columns: capabilityColumns"
                  ></tr>
                </table>
              </section>

              <section class="summary-pair">
                <p class="ui-label-m-bold">
                  {{ OFFERING_FORM.FUNCTIONALITY.USE_CASES.SECTION_TITLE }}
                </p>
                <table
                  rds-table
                  [dataSource]="useCaseDataSource"
                  alternation="vertical"
                >
                  <ng-container rdsColumnDef="name">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{
                        OFFERING_FORM.FUNCTIONALITY.USE_CASES.TABLE_COLUMNS
                          .USE_CASE_NAME
                      }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      {{ element.name }}
                    </td>
                  </ng-container>

                  <ng-container rdsColumnDef="description">
                    <th rds-header-cell *rdsHeaderCellDef>
                      {{
                        OFFERING_FORM.FUNCTIONALITY.USE_CASES.TABLE_COLUMNS
                          .USE_CASE_DESCRIPTION
                      }}
                    </th>
                    <td rds-cell *rdsCellDef="let element">
                      <span>{{ element.description }}</span>
                    </td>
                  </ng-container>
                  <tr rds-header-row *rdsHeaderRowDef="useCaseColumns"></tr>
                  <tr
                    rds-row
                    *rdsRowDef="let row; columns: useCaseColumns"
                  ></tr>
                </table>
              </section>
            </div>
          </section>
        </div>

        <div class="form-actions">
          <button rds-secondary-button rdsStepperPrevious size="l">
            {{ BUTTONS.PREVIOUS_STEP }}
          </button>
          <div class="draft-and-publish">
            <button
              *inexpFeatureFlag="'focus_inexp_1361_save_draft'"
              rds-secondary-button
              (click)="handleDraftSave()"
              size="l"
              [disabled]="isDraftSaving()"
            >
              @if (isDraftSaving()) {
                <div class="loading-container">
                  <rds-progress-spinner
                    class="loading-spinner"
                  ></rds-progress-spinner>
                  {{ BUTTONS.DRAFT_SAVING }}
                </div>
              } @else {
                {{ BUTTONS.SAVE_DRAFT }}
              }
            </button>

            <button
              rds-primary-button
              (click)="handlePublish()"
              size="l"
              [disabled]="isPublishing()"
            >
              @if (isPublishing()) {
                <div class="loading-container">
                  <rds-progress-spinner
                    class="loading-spinner"
                  ></rds-progress-spinner>
                  {{ BUTTONS.PUBLISHING }}
                </div>
              } @else {
                {{ BUTTONS.PUBLISH }}
              }
            </button>
          </div>
        </div>
      </rds-step>
    </rds-stepper>
    }
  </div>
</div>
